<template>
  <loading
    :active="this.releaseType"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="true"
    :color="'#fff'"
    :background-color="'#000'"
    :opacity="'0.8'"
    :loader=" dots"
    :style="this.style"
  >
    <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
    <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
      <div style="margin: auto"> -->
        <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
        <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
      <!-- </div>
    </div> -->
  </loading>
  <loading :active="this.allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="!this.showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <Header :title="showLang[selectLang]['views']['EventAdd']['page_name']" @childLang="useLang">
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventAdd']['advertising_source']}}
      </div>
      <div class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        <img class="mt-0.5 ml-0.5" width="25" src="https://dev-private.autoturn.net/img/tiktok_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Tiktok
        </div>
      </div>
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['EventAdd']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden bg-gray-200">
      <div class="w-1/5 mx-auto p-4">
        <!-- 新手教學 -->
        <div class="w-full rounded-xl bg-white p-4" :style="nowStep === 888 ? { zIndex: 100, position: 'relative', height: `520px` } : { height: `520px` }">
          <div v-show="false" class="h-16" :class="{ 'ring-4 border-blue-400': nowStep === 888 }">
            <span v-if="!isEdit" class="break-all" @click="campaignNameEdit(true)" >{{campaign_name}}</span>
            <!-- 新手教學 -->
            <span v-if="!isEdit && campaign_name == ''" class="text-gray-400 break-all" @click="campaignNameEdit(true)">{{showLang[selectLang]['views']['EventAdd']['campaign_name_text']}}</span>
            <textarea v-if="isEdit" class="w-full border p-1" v-model="campaign_name" @blur="campaignNameEdit(false)"></textarea>
            <i class="pi pi-pencil cursor-pointer float-right" style="fontSize: 0.8rem" @click="isEdit=!isEdit"></i>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `480px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item.show"
                @click="getHere(item.target, item.click)"
                :class="[
                  item.click? 'text-gray-700 p-1 cursor-pointer h-8 -mb-6' : 'text-gray-300',
                  item.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-36 break-words">{{ item.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" v-if="item.open">
                <div
                  :class="item.click? 'text-gray-700 cursor-pointer ml-1' : 'text-gray-300'"
                  @click="getHere(item.target, item.click)"
                  v-for="(sub, idx) in item.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-40 break-words">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新手教學 -->
      <div
        id="edit_content"
        class="w-4/5 mx-auto p-4 overflow-y-auto"
        ref="scrollcontent"
        :style="{ overflowY: nowStep > -1 ? 'hidden !important' : null }"
      >
        <div v-show="target == 1">
          <CampaignName
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:teachingId="teaching_id"
            v-bind:lang="showLang[selectLang]"
            v-model:viewDatalist="campaign_name"
            @childCampaignName="campaignData"
            @childOpenTeaching="openTeaching"
          />
          <MarketingMethod
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:currencyList="currencyData"
            v-bind:teachingId="teaching_id"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-model:viewDatalist="methodData"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childTargetKW="methodTargetKW"
            @childTargetDM="methodTargetDM"
            @childTargetLA="methodTargetLA"
            @childTargetCF="methodTargetCF"
            @childTargetAD="methodTargetAD"
            @childBudgetKWTotal="methodBudgetKWTotal"
          />
          <KeywordMix
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:targetKW="showTargetKW"
            v-bind:viewDatalist="keywordData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-model:viewDatalist="methodData"
            v-bind:returnKeywordsList="returnKeywordsList"
            v-bind:noTiktokData="noTiktokStatus"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childKeywordUrl="keywordUrl"
            @childUrlKeywordsList="urlKeywordsList"
            @childKeywordsSuggestList="keywordsSuggestList"
            @childSelectedCategories="childSelectedCategories"
          />
          <AdvertisingMix
            :guideStep="nowStep"
            v-if="showTargetLA"
            v-bind:showAdvertisingMix="showAdvertisingMix"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="lookData"
            v-bind:adaccountId="advertiser_id"
            v-bind:pixelId="formPixelId"
            v-bind:productUrl="productUrl"
            v-bind:lang="showLang[selectLang]"
          />
          <ConfidentialAudience
            v-if="showTargetCF"
            v-bind:showMarketingDate="showMarketingDate"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="dateData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
          />
          <MarketingDate
            v-bind:showMarketingDate="showMarketingDate"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="dateData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-bind:efficientAi="efficientAi"
            v-model:viewDatalist="methodData"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childGapTime="dateGapTime"
            @childEndTime="dateEndTime"
            @childUseEndDate="dateUseEndDate"
          />
        </div>
        <!-- <div v-show="target == 2">
          <KeywordMix v-if="showTargetKW || showTargetLA" v-bind:editPage="cancelEdit" v-bind:targetKW="showTargetKW" v-bind:viewDatalist="keywordData" @childKeywordUrl="keywordUrl" />
          <AdvertisingMix v-if="showTargetLA" v-bind:showAdvertisingMix="showAdvertisingMix" v-bind:editPage="cancelEdit" v-bind:viewDatalist="lookData" v-bind:adaccountId="advertiser_id" v-bind:pageId="formPageId" v-bind:productUrl="productUrl" />
        </div> -->
        <div v-show="target == 2">
          <GoalsAndBudget
            :guideStep="nowStep"
            v-bind:showGoalsAndBudget="showGoalsAndBudget"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="goalsData"
            v-bind:getDate="returnGapTime"
            v-bind:budgetKWTotal="budgetKW"
            v-bind:useEndDate="returnUseEndDate"
            v-bind:formMinAddition="updateMinAddition"
            v-bind:currencyList="currencyData"
            v-bind:lang="showLang[selectLang]"
            v-bind:useLang="selectLang"
            v-bind:youtubeClose="youtubeClose"
            v-bind:efficientAi="efficientAi"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childObjective="goalsObjective"
            @childObjectiveOption="objectiveOption"
          />
          <Regions
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="regionsData"
            v-bind:targetDM="showTargetDM"
            v-model:selectCountries="selectCountries"
            v-model:selectLangs="selectLangs"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-bind:efficientAi="efficientAi"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
          />
          <Relationship
            :guideStep="nowStep"
            v-bind:showRelationship="showRelationship"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="exAudiencesData"
            v-bind:campaignId="db_campaign_id"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
          />
        </div>
        <div v-show="target == 3">
          <PositionAndDevice
            ref="PositionAndDevice"
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="pdData"
            v-bind:keywordViewDatalist="keywordData"
            v-bind:autoPublisher="auto_publisher"
            v-bind:publisherPlatforms="publisher_platforms"
            v-bind:keywordsSelectedList="keywordsSelectedCategories"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childReturnKeywords="childReturnKeywords"
            @childNoTiktok="childNoTiktok"
          />
          <Identity
            :guideStep="nowStep"
            v-bind:showIdentity="showIdentity"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="idData"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            @childPageId="eventPageId"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
          />
          <Material
            :guideStep="nowStep"
            v-if="showMaterial"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="postData"
            v-bind:pageId="formPageId"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:campaignId="db_campaign_id"
            v-bind:lang="showLang[selectLang]"
            v-bind:youtubeClose="youtubeClose"
            v-bind:selectStatus="selectStatus"
            v-bind:efficientAi="efficientAi"
            @checkClose="changeYoutubeType"
            @childYoutube="childYoutube"
            @childActiveScroll="activeScroll"
            @nextStep="nextStep"
            @emptyStep="nextStep"
          />
          <AdvertisingMaterial
            :guideStep="nowStep"
            v-bind:editPage="cancelEdit"
            v-bind:pageId="formPageId"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:changeFormId="changeFormId"
            v-bind:changeMessageId="changeMessageId"
            v-bind:lang="showLang[selectLang]"
            v-model:viewDatalist="adMaterialDataNew"
            @childFormId="eventFormId"
            @childMessageId="eventMessageId"
            @childContent="adMaterialContent"
            @setAdvertisingMaterialType="setAdvertisingMaterialType"
          />
          <Form
            :guideStep="nowStep"
            v-if="showForm"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="idData"
            v-bind:pageId="formPageId"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:firstFormId="first_form_id"
            v-bind:formId="formId"
            v-bind:teachingId="teaching_id"
            v-bind:useTeachDetail="use_teach_detail"
            v-bind:targetAllSkip="targetAllSkip"
            v-bind:formTeachingOver="formTeachingOver"
            v-bind:selectLang="selectLang"
            v-bind:campaignId="db_campaign_id"
            v-bind:lang="showLang[selectLang]"
            @childChangeFormId="formChangeFormId"
            @childFormTeachingOver="activeFormTeachingOver"
            style="display:none;"
          />
          <Msg
            :guideStep="nowStep"
            v-if="showMsg"
            v-bind:editPage="cancelEdit"
            v-bind:viewDatalist="idData"
            v-bind:pageId="formPageId"
            v-bind:goalsObjective="getGoalsObjective"
            v-bind:firstMessageId="first_message_id"
            v-bind:messageId="messageId"
            v-bind:teachingId="teaching_id"
            v-bind:useTeachDetail="use_teach_detail"
            v-bind:targetAllSkip="targetAllSkip"
            v-bind:msgTeachingOver="msgTeachingOver"
            v-bind:campaignId="db_campaign_id"
            v-bind:lang="showLang[selectLang]"
            @childChangeMessageId="formChangeMessageId"
            @childMsgTeachingOver="formMsgTeachingOver"
            style="display:none;"
          />
        </div>
      </div>
    </main>
	<!-- 新手教學 -->
    <footer class="block bg-white fixed w-full bottom-0" :style=" nowStep === 999 ? { zIndex: 100 } : null">
      <div class="h-1 bg-green-700 progressbar" style="width:20%" :style="{width: `${process}%`}"></div>
      <div class="mx-auto pl-8 pr-28 py-4">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="border-gray-400 space-x-2">
            <button
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >{{showLang[selectLang]['views']['EventAdd']['save_button']}}</button>
            <button
              v-if="canRelease"
              class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400"
              @click="release()"
              >{{showLang[selectLang]['views']['EventAdd']['release_button']}}</button>
          </div>
          <div class="border-gray-400 space-x-2">
            <span>{{showLang[selectLang]['views']['EventAdd']['process_text_a']}} {{process}} % {{showLang[selectLang]['views']['EventAdd']['process_text_b']}}</span>
          </div>
          <div class="border-gray-400 space-x-2 mr-16">
            <button
              v-if="this.target != 1"
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="prev()"
              :disabled="process <= 0"
            >{{showLang[selectLang]['views']['EventAdd']['prev_text']}}</button>
            <button
              class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
              @click="next()"
            >{{showLang[selectLang]['views']['EventAdd']['next_text']}}</button>
          </div>
        </div>
      </div>
    </footer>

    <!-- 新手教學 -->
    <Mask :isDisplay="nowStep > -1" />
    <StartTips
      v-if="nowStep === 0"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <CampaignNameTips
      v-if="nowStep == 111"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <MarketingMehodTips
      v-if="(nowStep > 0 && nowStep <= 6) || nowStep == 2001"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <KeywordTips
      v-if="nowStep >= 7 && nowStep <= 12"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <AdvertisingMixTips
      v-if="nowStep >= 13 && nowStep <= 18"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <GoalsAndBudgetTips
      v-if="(nowStep >= 19 && nowStep <= 34) || (nowStep == 271 || nowStep == 272)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      :efficientAi="efficientAi"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <RegionsTips
      v-if="nowStep >= 35 && nowStep <= 39"
      :nowStep="nowStep"
      :selectLang="selectLang"
      :efficientAi="efficientAi"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <RelationshipTips
      v-if="nowStep >= 40 && nowStep <= 44"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <PositionAndDeviceTips
      v-if="nowStep >= 45 && nowStep <= 49"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <IdentityTips
      v-if="nowStep === 50"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
    />
    <MaterialTips
      v-if="(nowStep >= 51 && nowStep <= 57) || (nowStep >= 501 && nowStep <= 503) || (nowStep == 11001 || nowStep == 11002)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @backStep="backStep"
      @closeTips="closeTips"
    />
    <AdvertisingMaterialTips
      v-if="(nowStep >= 58 && nowStep <= 74) || (nowStep == 5801)"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
      @switchToOtherStep="switchToOtherStep"
    />
    <FormTips
      v-if="nowStep >= 75 && nowStep <= 78 && showForm"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <MsgTips
      v-if="nowStep >= 75 && nowStep <= 78 && showMsg"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
    <!-- <NameTips
      v-if="nowStep === 888"
      :nowStep="nowStep"
      :selectLang="selectLang"
      @nextStep="nextStep"
    /> -->
    <NextSectionTips
      v-if="nowStep === 999"
      :nowStep="nowStep"
      :selectLang="selectLang"
    />
    <!-- 新手教學 -->
  </div>
</template>

<script>
  // <!-- 新手教學 -->
  import Mask from '@/components/Event/Mask.vue';
  import StartTips from '@/components/Tips/StartTips.vue';
  import CampaignNameTips from '@/components/Tips/CampaignNameTips.vue';
  import MarketingMehodTips from '@/components/Tips/MarketingMehodTips.vue';
  import KeywordTips from '@/components/Tips/KeywordTips.vue';
  import AdvertisingMixTips from '@/components/Tips/AdvertisingMixTips.vue';
  import GoalsAndBudgetTips from '@/components/Tips/GoalsAndBudgetTips.vue';
  import RegionsTips from '@/components/Tips/RegionsTips.vue';
  import RelationshipTips from '@/components/Tips/RelationshipTips.vue';
  import PositionAndDeviceTips from '@/components/Tips/PositionAndDeviceTips.vue';
  import IdentityTips from '@/components/Tips/IdentityTips.vue';
  import MaterialTips from '@/components/Tips/MaterialTips.vue';
  import FormTips from '@/components/Tips/FormTips.vue';
  import MsgTips from '@/components/Tips/MsgTips.vue';
  import AdvertisingMaterialTips from '@/components/Tips/AdvertisingMaterialTips.vue';
  import NextSectionTips from '@/components/Tips/NextSectionTips.vue';
  import NameTips from '@/components/Tips/NameTips.vue';
  // <!-- 新手教學 -->
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/TikTokEvent/CampaignName.vue'
  import MarketingMethod from '@/components/TikTokEvent/MarketingMethod.vue'
  import MarketingDate from '@/components/TikTokEvent/MarketingDate.vue'
  import ConfidentialAudience from '@/components/TikTokEvent/ConfidentialAudience.vue'
  import KeywordMix from '@/components/TikTokEvent/KeywordMix.vue'
  import AdvertisingMix from '@/components/TikTokEvent/AdvertisingMix.vue'
  import GoalsAndBudget from '@/components/TikTokEvent/GoalsAndBudget.vue'
  import Regions from '@/components/TikTokEvent/Regions.vue'
  import Identity from '@/components/TikTokEvent/Identity.vue'
  import Relationship from '@/components/TikTokEvent/Relationship.vue'
  import PositionAndDevice from '@/components/TikTokEvent/PositionAndDevice.vue'
  import Material from '@/components/TikTokEvent/Material.vue'
  import AdvertisingMaterial from '@/components/TikTokEvent/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/tiktok_lang.json'

  export default {
    name: 'Home',
    components: {
      // <!-- 新手教學 -->
      Mask,
      StartTips,
      CampaignNameTips,
      MarketingMehodTips,
      KeywordTips,
      AdvertisingMixTips,
      GoalsAndBudgetTips,
      RegionsTips,
      RelationshipTips,
      PositionAndDeviceTips,
      IdentityTips,
      MaterialTips,
      FormTips,
      MsgTips,
      AdvertisingMaterialTips,
      NextSectionTips,
      NameTips,
      // <!-- 新手教學 -->
      Header,
      CampaignName,
      MarketingMethod,
      MarketingDate,
      ConfidentialAudience,
      KeywordMix,
      AdvertisingMix,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        nowStep: -1, // <!-- 新手教學 -->
        openStep: 1, // <!-- 新手教學 -->
        teaching_id: 0, // <!-- 新手教學 -->
        isAreadlyOpenShowTargetKW: false, // <!-- 新手教學 -->
        isAreadlyOpenshowTargetLA: false, // <!-- 新手教學 -->
        isAreadlyOpenshowGoalsAndBudget: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowRegions: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowRelationship: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowPositionAndDevice: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowMaterial: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowAdvertisingMaterial: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyOpenshowFormMsg: false, // <!-- 新手教學-要跟scroll搭配 -->
        isAreadlyShowRegionsTips: true, // <!-- 新手教學 -->
        isAreadlyShowRelationshipTips: true, // <!-- 新手教學 -->
        advertisingMaterialType: 1, // <!-- 新手教學 -->
        use_teach_detail: true, // <!-- 新手教學 -->
        msgTeachingOver: 0, // <!-- 新手教學 -->
        formTeachingOver: 0, // <!-- 新手教學 -->
        isAlreadyShowNameTips: false,
        targetTwoStatus: true,
        targetThreeStatus: true,
        targetAllSkip: 1,

        showCampaignData: false,
        db_campaign_id: null,
        showMarketingDate: false,
        showAdvertisingMix:false,
        showGoalsAndBudget: false,
        showRelationship: false,
        showIdentity: false,
        canRelease: true,
        display: false,
        cancelEdit: false,
        process: 0,
        showTargetKW: true,
        urlKeywordsListData: [],
        keywordsSuggestListData: [],
        showTargetDM: false,
        showTargetLA: false,
        showTargetCF: false,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showAdvertisingMaterial:true,
        showForm:true,
        showMsg:true,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        advertiser_id: null,
        productUrl: null,
        adaccount_name: null,
        target: 1,
        click: 0,
        formPixelId: null,
        formPageId: null,
        selectStatus: false,
        formId: null,
        messageId: null,
        changeFormId: null,
        changeMessageId: null,
        menu: [],
        Budget_KW_result: null,
        total_budget: null,
        keywordsSelectedCategories:{},
        returnKeywordsList: {},
        noTiktokStatus: false,
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:'',
                    Target_DM:null,
                    Budget_DM:'',
                    Target_LA:null,
                    Budget_LA:'',
                    Target_RT:null,
                    Budget_RT:'',
                    use_similar_audience_status:0,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    retargeting:null,
                    daily_budget:null
                  },
        dateData: {
                    start_date:null,
                    end_date:null,
                    use_end_date:null,
                  },
        keywordData: {
                      product_url:null,
                      keywords:null,
                      keyword_list:null,
                      base_keyword_list: [],
                      select_keywords:null,
                      creator_action_categories: [],
                      interest_categories: [],
                      video_action_categories: [],
                      interest_keywords: [],
                      hashtags: []
                    },
        lookData: {
                    default_lookalikes:null,
                    custom_lookalikes:null,
                    custom_lookalikes_selected:null,
                    default_lookalikes_list:null,
                    custom_lookalikes_list:null
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    budget_increase:null,
                    budget_switch:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      locations_list:[],
                      locations_selected:null,
                      location_types:null,
                      locations:null,
                      locales:null,
                      locales_list: [],
                      locales_selected:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      excluded_audiences_list:[],
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  placement_type:null,
                  placements:null,
                  device_platforms: null,
                  operating_systems:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  identity_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  identity_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:[],
                  db_select_article:null,
                  select_creatives:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:[],
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:[],
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:[],
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        first_message_id: null,
        AdvertisingMaterialStatus: undefined,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 5,
        allPageLoading: false,
        youtubeClose: false,
        isEmptySelect: '',
      }
    },
    created() {
      console.log('id:'+this.$route.params.id);
      console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_create_default.php', Qs.stringify({
            s_code: this.$route.params.id,
            advertiser_id: this.$route.params.adaccount_id,
            campaign_id: this.$route.params.campaign_id
          }))
          .then((response) => {
            this.releaseType = false;
            if(response.data.status == 'success'){
              this.campaign_id = this.$route.params.campaign_id
              this.campaign_name = response.data.return_data.campaign_name
              this.originName = response.data.return_data.campaign_name;
              this.advertiser_id = response.data.return_data.advertiser_id
              this.adaccount_name = response.data.return_data.adaccount_name
              this.productUrl = response.data.return_data.product_url

              this.showTargetKW = response.data.return_data.Target_KW
              this.showTargetLA = response.data.return_data.Target_LA

              let startTime = response.data.return_data.start_date;
              let endTime = response.data.return_data.end_date;
              let diffType = 'day';

              let gapTime = 0;

              if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                diffType = diffType.toLowerCase();
                var sTime = new Date(startTime); //開始時間
                var eTime = new Date(endTime); //結束時間
                //作為除數的數字
                var timeType = 1;
                switch (diffType) {
                    case"second":
                        timeType =1000;
                    break;
                    case"minute":
                        timeType =1000*60;
                    break;
                    case"hour":
                        timeType =1000*3600;
                    break;
                    case"day":
                        timeType =1000*3600*24;
                    break;
                    default:
                    break;
                }
                gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
              }

              this.budgetKW = response.data.return_data.Budget_KW;
              this.returnGapTime = gapTime;
              this.returnEndTime = response.data.return_data.end_date;
              this.returnUseEndDate = response.data.return_data.use_end_date;
              this.Budget_KW_result = response.data.return_data.Budget_KW_result;
              this.total_budget = response.data.return_data.total_budget;

              this.currencyData = {
                                    currency: response.data.return_data.currency,
                                    currency_name: response.data.return_data.currency_name,
                                    currency_symbol: response.data.return_data.currency_symbol,
                                    currency_min_price: response.data.return_data.currency_min_price,
                                    currency_video_min_price: response.data.return_data.currency_video_min_price,
                                    currency_suggest_price: response.data.return_data.currency_suggest_price,
                                    currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                    KW_min_price: response.data.return_data.KW_min_price,
                                    DM_min_price: response.data.return_data.DM_min_price,
                                    LA_min_price: response.data.return_data.LA_min_price,
                                    RT_min_price: response.data.return_data.RT_min_price,
                                  }

              this.methodData = {
                                  Target_KW : response.data.return_data.Target_KW,
                                  Budget_KW : response.data.return_data.Budget_KW,
                                  Target_DM : response.data.return_data.Target_DM,
                                  Budget_DM : response.data.return_data.Budget_DM,
                                  Target_LA : response.data.return_data.Target_LA,
                                  Budget_LA : response.data.return_data.Budget_LA,
                                  Target_RT : response.data.return_data.Target_RT,
                                  Budget_RT : response.data.return_data.Budget_RT,
                                  Target_CF : response.data.return_data.Target_CF,
                                  Budget_CF : response.data.return_data.Budget_CF,
                                  Target_AD : response.data.return_data.Target_AD,
                                  Budget_AD_min : response.data.return_data.Budget_AD_min,
                                  Budget_AD_max : response.data.return_data.Budget_AD_max,
                                  use_similar_audience_status : response.data.return_data.use_similar_audience_status,
                                  use_confldential_audience_status : response.data.return_data.use_confldential_audience_status,
                                  retargeting : response.data.return_data.retargeting
                                }
              this.dateData = {
                                start_date : response.data.return_data.start_date,
                                end_date : response.data.return_data.end_date,
                                use_end_date : response.data.return_data.use_end_date
                              }

              this.showMarketingDate = true;

              this.keywordData = {
                                    product_url : response.data.return_data.product_url,
                                    keywords : response.data.return_data.keywords,
                                    keyword_list : response.data.return_data.keyword_list,
                                    base_keyword_list: response.data.return_data.base_keyword_list,
                                    select_keywords : response.data.return_data.keywords,
                                    creator_action_categories: response.data.return_data.creator_action_categories,
                                    interest_categories: response.data.return_data.interest_categories,
                                    video_action_categories: response.data.return_data.video_action_categories,
                                    interest_keywords: response.data.return_data.interest_keywords,
                                    hashtags: response.data.return_data.hashtags,
                                    selected_keywords_list: response.data.return_data.selected_keywords_list,
                                  }

              this.showAdvertisingMix = true;

              this.goalsData = {
                                  objective_type : response.data.return_data.objective_type,
                                  objective_option : response.data.return_data.objective_option,
                                  objective_list : response.data.return_data.objective_list,
                                  effect : response.data.return_data.effect,
                                  currency_video_min_price: response.data.return_data.currency_video_min_price,
                                  budget_increase : response.data.return_data.budget_increase,
                                  budget_switch : response.data.return_data.budget_switch,
                                  risk_automatic : response.data.return_data.risk_automatic,
                                  risk_level_list: response.data.return_data.risk_level_list,
                                  risk_level: response.data.return_data.risk_level
                                }

              console.log('this.goalsData');
              console.log(this.goalsData);

              this.showGoalsAndBudget = true;

              this.regionsData = {
                                    locations_list : response.data.return_data.locations_list,
                                    locations_selected : response.data.return_data.locations_selected,
                                    locations : response.data.return_data.locations,
                                    locales : response.data.return_data.locales,
                                    locales_list : response.data.return_data.locales_list,
                                    locales_selected : response.data.return_data.locales_selected,
                                    gender : response.data.return_data.gender,
                                    age_groups : response.data.return_data.age_groups
                                  }

              this.selectCountries = response.data.return_data.locations

              this.selectLangs = response.data.return_data.locales

              axios
                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_audiences_list.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  advertiser_id: this.$route.params.adaccount_id
                }))
                .then((exResponse) => {
                  console.log('exResponse');
                  console.log(exResponse);
                  this.exAudiencesData = {
                                            excluded_audiences : response.data.return_data.excluded_audiences,
                                            excluded_audiences_list : exResponse.data.excluded_audiences_list,
                                            default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                            custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                            custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                          }
                });

              console.log('this.exAudiencesData');
              console.log(this.exAudiencesData);

              this.showRelationship = true;

              this.pdData = {
                              auto_publisher : response.data.return_data.auto_publisher,
                              publisher_platforms : response.data.return_data.publisher_platforms,
                              publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                              placement_type : response.data.return_data.placement_type,
                              placements : response.data.return_data.placements,
                              device_platforms: response.data.return_data.device_platforms,
                              operating_systems : response.data.return_data.operating_systems,
                              user_os_list : response.data.return_data.user_os_list
                            }

              this.auto_publisher = response.data.return_data.auto_publisher
              this.publisher_platforms = response.data.return_data.publisher_platforms

              this.idData = {
                              identity_id : response.data.return_data.identity_id,
                              adpages_list : response.data.return_data.adpages_list,
                            }

              this.showIdentity = true;

              this.postData = {
                                identity_id : response.data.return_data.identity_id,
                                special_ad_category : response.data.return_data.special_ad_category,
                                disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                creative_optimize: response.data.return_data.creative_optimize,
                                db_select_article : response.data.return_data.post_ids,
                              }

              this.adMaterialData = {
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize: response.data.return_data.creative_optimize,
                                      creative_array : response.data.return_data.creative_array,
                                    }

              this.tmpAdMaterialDataNew = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize: response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array
                                          }

              this.formPixelId = response.data.return_data.pixel_id

              this.formPageId = response.data.return_data.identity_id

              this.first_form_id = response.data.return_data.first_form_id

              this.first_message_id = response.data.return_data.first_message_id

              // console.log('load this.adMaterialData');
              // console.log(this.adMaterialData);

              // console.log('response.data.return_data.form_addition:'+response.data.return_data.form_addition);
              // console.log('b this.goalsData:'+this.goalsData.form_addition);
              this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
              // console.log('a this.goalsData:'+this.goalsData.form_addition);

              this.showCampaignData = true;

              console.log('response.data.return_data.openStep');
              console.log(response.data.return_data.openStep);
              console.log('b this.nowStep');
              console.log(this.nowStep);
              console.log('b this.teaching_id');
              console.log(this.teaching_id);

              this.nowStep = -1;
              if(response.data.return_data.openStep == 0){
                this.nowStep = 0;
                this.targetTwoStatus = false
                this.targetThreeStatus = false
                this.targetAllSkip = 0
                this.isAreadlyShowRegionsTips = false
                this.isAreadlyShowRelationshipTips = false
                this.teaching_id = response.data.return_data.teaching_id;
              }

              console.log('a this.nowStep');
              console.log(this.nowStep);
              console.log('a this.teaching_id');
              console.log(this.teaching_id);

              this.$router.push({ query: { step: this.nowStep }});
            }

            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_title'],
                text: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['created']['login_error_swal_confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    },
    // <!-- 新手教學 -->
    watch:{
      // showTargetKW(val) {
      //   if (val) {
      //     if (!this.isAreadlyOpenShowTargetKW) {
      //       this.nowStep = 7;
      //       this.$router.push({ query: { step: this.nowStep }});
      //     }
      //   }
      // },
      // showTargetLA(val) {
      //   if (val) {
      //     if (!this.isAreadlyOpenshowTargetLA) {

      //       this.nowStep = 13;
      //       this.$router.push({ query: { step: this.nowStep }});
      //       setTimeout(()=> {
      //         this.$refs.scrollcontent.scrollTo({
      //           top: 300,
      //           behavior: 'smooth'
      //         });

      //       }, 1000);
      //     }
      //   }
      // },
      target(val) {
        console.log('target');
        console.log(val);
        if (val === 2) {
          if(this.targetTwoStatus == false){
            this.nowStep = 19;
            this.$router.push({ query: { step: this.nowStep }});

            console.log('this.nowStep');
            console.log(this.nowStep);

            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        } else if (val === 3) {
          if(this.targetThreeStatus == false){
            this.nowStep = 45;
            this.$router.push({ query: { step: this.nowStep }});

            console.log('this.nowStep');
            console.log(this.nowStep);

            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        }
      },
      AdvertisingMaterialStatus(status) {
        // console.log('watch AdvertisingMaterialStatus');
        // console.log(status);
        if (status) {
          // console.log(status);
          this.$nextTick().then(() =>
            this.$refs.scrollcontent.scrollTo({
              top: 1505,
              behavior: 'smooth'
            })
          );
        }
      }
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
    },
    // <!-- 新手教學 -->
    mounted() {
      console.log('this.$route.query');
      console.log(this.$route.query);
      console.log('this.nowStep');
      console.log(this.nowStep);
      if (this.$route.query.step) {
        this.nowStep = Number(this.$route.query.step);
      } else {
        this.$router.push({ query: { step: this.nowStep }});
      }
      // scroll
      const _self = this;
      const scrollRegions = this.isAreadlyOpenshowRegions
      const scrollRelationship = this.isAreadlyOpenshowRelationship
      this.$refs.scrollcontent.addEventListener('scroll', function () {
        console.log('_self.isAreadlyOpenshowRegions');
        console.log(_self.isAreadlyOpenshowRegions);
        console.log('_self.isAreadlyOpenshowRelationship');
        console.log(_self.isAreadlyOpenshowRelationship);
        if (_self.target === 2 && _self.nowStep === -1) {
          let deRegionsTop = 780
          let regionsTop = 780
          let deRelationshipTop = 1000
          let relationshipTop = 1450
          if(_self.efficientAi == true){
            deRegionsTop = 300
            regionsTop = 300
            deRelationshipTop = 800
            // relationshipTop = 655
          }

          console.log('_self.isAreadlyShowRegionsTips');
          console.log(_self.isAreadlyShowRegionsTips);
          console.log('_self.isAreadlyShowRelationshipTips');
          console.log(_self.isAreadlyShowRelationshipTips);
          console.log('_self.refs.scrollcontent.scrollTop');
          console.log(_self.$refs.scrollcontent.scrollTop);
          console.log('deRegionsTop');
          console.log(deRegionsTop);
          console.log('deRelationshipTop');
          console.log(deRelationshipTop);

          if (_self.$refs.scrollcontent.scrollTop >= deRegionsTop && !_self.isAreadlyShowRegionsTips && (_self.isAreadlyOpenshowRegions == false || typeof _self.isAreadlyOpenshowRegions == undefined)) {
            _self.nowStep = 35;
            _self.$router.push({ query: { step: _self.nowStep }});
            _self.$refs.scrollcontent.scrollTo({
              top: regionsTop,
              behavior: 'smooth'
            });
          }

          if (_self.$refs.scrollcontent.scrollTop >= deRelationshipTop && !_self.isAreadlyShowRelationshipTips && (_self.isAreadlyOpenshowRelationship == false || typeof _self.isAreadlyOpenshowRelationship == undefined)) {
            _self.nowStep = 40;
            _self.$router.push({ query: { step: _self.nowStep }});
            _self.$refs.scrollcontent.scrollTo({
              top: relationshipTop,
              behavior: 'smooth'
            });
          }

        }
      });
      // scroll
    },
    methods: {
      'releaseType'(v){
        console.log('releaseType');
        console.log(v);
      },
      changeYoutubeType(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.youtubeClose = 'false_'+todayForm;

        console.log('eventadd changeYoutubeType');
        console.log(this.youtubeClose);
      },
      childYoutube(v){
        this.youtubeClose = v;
      },
      useLang(v){
        console.log('event methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('this.selectLang');
        console.log(this.selectLang);
        // console.log('showLang['+v+'][msg]');
        // console.log(this.showLang[v]['msg']);

        document.title = this.showLang[this.selectLang]['views']['EventAdd']['mounted']['page_title'] + ' - AutoTurn';

        this.menu = [
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_0_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_1_submenu_5_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 1,
            click: 1
          },
          // {
          //   title: '關鍵字與受眾',
          //   submenu: [
          //     {title: '精準興趣關鍵字', show: true, checked: false},
          //     {title: '類似受眾廣告組合', show: true, checked: false},
          //   ],
          //   open: true,
          //   show: true,
          //   target: 2
          // },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_2_submenu_3_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2,
            click: 0
          },
          {
            title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_title'],
            submenu: [
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_1_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_2_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_3_title'], show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['EventAdd']['menu']['step_3_submenu_4_title'], show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 3,
            click: 0
          },
        ];
      },
      // <!-- 新手教學 -->
      campaignData(value){
        console.log('campaignData'+value);
        this.campaign_name = value
      },
      tryTest() {
        /* this.$refs.scrollcontent.scrollTo({
          top: 181,
          behavior: 'smooth'
        });
        console.log(this.$refs.scrollcontent.scrollTop); */
        console.log('tryTest');
        console.log(this.showAdvertisingMaterial);
      },
      // <!-- 新手教學 -->
      backStep() {
        this.nowStep = this.nowStep - 1;
        this.$router.push({ query: { step: this.nowStep }});
      },
      emptyStep(val){
        console.log('eventadd emptyStep: '+val);

        var _tmp_emptyStep = val.split('_');
        console.log(_tmp_emptyStep);

        // this.nowStep = _tmp_emptyStep[0];
        // this.$router.push({ query: { step: this.nowStep }});
      },
      nextStep(value) {
        console.log('b event add nextStep');
        console.log(this.nowStep);
        console.log('this.getGoalsObjective');
        console.log(this.getGoalsObjective);

        console.log('value');
        console.log(value);

        if(value != '' && value != null && typeof value != undefined){
          this.isEmptySelect = value
        }

        let overStepArray = [6, 12, 18, 44, 57, 78];
        let overStep = 0;
        let skip = 0;
        for(let i = 0; i < overStepArray.length; i++){
          if(this.nowStep == overStepArray[i]){
            overStep = 1;
          }
        }

        if(this.nowStep == 66){
          skip = 1;
        }

        if(overStep == 1){
          axios
            .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              id: this.teaching_id,
              campaign_id: this.db_campaign_id,
              campaign_objective: this.getGoalsObjective,
              skip: skip,
              step: this.nowStep,
              active: ''
            }))
            .then((response) => {
              if(response.data.teaching_status == 'Y'){
                this.teaching_id = 0;

                console.log('isEmptySelect');
                console.log(this.isEmptySelect);

                if(this.isEmptySelect != '' && this.isEmptySelect != null && typeof this.isEmptySelect != undefined){
                  this.postData.select_article = [];
                  this.isEmptySelect = '';
                }
              }

              if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                this.teaching_id = response.data.id
              }
              // console.log(response);
              // if(response.data.status == 'success'){
                // this.urlKeywords = response.data.return_data

                // console.log(this.urlKeywords);
              // }
            });
        }

        if(this.nowStep == 44 || this.nowStep == 45){
          console.log('this.targetTwoStatus');
          this.targetTwoStatus = true;
        }

        if(this.nowStep == 57 || this.nowStep == 78){
          console.log('this.targetThreeStatus');
          this.targetThreeStatus = true;
        }

        if(this.nowStep == 0){
          this.nowStep = 111;
          this.$router.push({ query: { step: this.nowStep }});
        } else if(this.nowStep == 111){
          this.nowStep = 1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 5) {
          this.nowStep = 2001;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 2001) {
          this.nowStep = 6;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 6) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 7) {
          console.log('stop');
          if(this.urlKeywordsListData.length > 0){
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
          } else {
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['nextStep']['nowStep_7_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['nextStep']['nowStep_7_swal_text'],
                      'warning'
                    )
          }
        } else if (this.nowStep === 12) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenShowTargetKW = true;
        } else if (this.nowStep === 18) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenshowTargetLA = true;
          // scroll
        } else if (this.nowStep === 34) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 22 && this.efficientAi == true) {
          this.nowStep = 28;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 24) {
          this.nowStep = 271;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 28 && this.efficientAi == true) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyOpenshowGoalsAndBudget = true;
        } else if (this.nowStep === 271) {
          this.nowStep = 25;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 27) {
          this.nowStep = 272;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 272) {
          this.nowStep = 28;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 39) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyShowRegionsTips = true;
        } else if (this.nowStep === 44) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
          this.isAreadlyShowRelationshipTips = true;
          // scroll
        } else if (this.nowStep === 50) {
          if(this.getGoalsObjective == 'MESSAGES'){
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
            if (this.nowStep === 51) {
              this.$refs.scrollcontent.scrollTo({
                top: 700,
                behavior: 'smooth'
              });
            }
          } else if (this.showAdvertisingMaterial) {
            console.log('scrollToTop50 showAdvertisingMaterial');
            this.nowStep = 58;
            this.$router.push({ query: { step: this.nowStep }});

            let scrollToTop = 750;
            if(this.getGoalsObjective == 'MESSAGES'){
              scrollToTop = 1500;
            }

            this.$refs.scrollcontent.scrollTo({
              top: scrollToTop,
              behavior: 'smooth'
            });
          } else {
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
            if (this.nowStep === 51) {
              this.$refs.scrollcontent.scrollTo({
                top: 1250,
                behavior: 'smooth'
              });
            }
          }
          // this.nowStep = -1;
          // this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 51) {
          this.nowStep = 11001;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11001 && this.getGoalsObjective == 'PRODUCT_CATALOG_SALES') {
          this.nowStep = 501;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11001 && this.getGoalsObjective == 'MESSAGES') {
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.nowStep = 11002;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 11002) {
          console.log('scrollToTop1500');
          this.nowStep = 58;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 1500,
            behavior: 'smooth'
          });
        } else if (this.nowStep === 11001) {
          this.nowStep = 52;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 503) {
          this.nowStep = 57;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 57) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 58 && this.getGoalsObjective == 'LEAD_GENERATION') {
          this.nowStep = 5801;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 5801 && this.getGoalsObjective == 'LEAD_GENERATION') {
          this.nowStep = 59;
          this.$router.push({ query: { step: this.nowStep }});
        } else if (this.nowStep === 63) {
          if (this.advertisingMaterialType === 1) {
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});
          } else {
            this.nowStep = 67;
            this.$router.push({ query: { step: this.nowStep }});
          }

        } else if (this.nowStep === 78) {
          this.nowStep = -1;
          this.$router.push({ query: { step: this.nowStep }});
        }
        // else if (this.nowStep === 888) {
        //   this.nowStep = -1;
        //   this.$router.push({ query: { step: this.nowStep }});
        // }
        else {
          console.log('else nowStep');
          if(this.nowStep != -1){
            console.log('nowStep != 1');
            this.nowStep = this.nowStep + 1;
            this.$router.push({ query: { step: this.nowStep }});

            if(this.targetTwoStatus == false){
              if (this.nowStep === 29) {
                this.$refs.scrollcontent.scrollTo({
                  top: 200,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 34) {
                this.$refs.scrollcontent.scrollTo({
                  top: 320,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 35) {
                this.$refs.scrollcontent.scrollTo({
                  top: 780,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 40) {
                this.$refs.scrollcontent.scrollTo({
                  top: 1250,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 40) {
                this.$refs.scrollcontent.scrollTo({
                  top: 1450,
                  behavior: 'smooth'
                });
              }
            }

            console.log('else this.targetThreeStatus');
            console.log(this.targetThreeStatus);
            if(this.targetThreeStatus == false){
              if (this.nowStep === 50) {
                this.$refs.scrollcontent.scrollTo({
                  top: 350,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 57) {
                this.selectStatus = true;
              }

              if (this.nowStep === 58) {
                this.showAdvertisingMaterial = true;
                this.showMsg = true;

                let scrollToTop = 650;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1150;
                }

                console.log('scrollToTop58');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 65) {
                console.log('nowStep 65');
                let scrollToTop = 1150;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2050;
                }

                console.log('scrollToTop65');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 68) {
                let scrollToTop = 800;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1300;
                }

                console.log('scrollToTop68');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 69) {
                let scrollToTop = 650;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1150;
                }

                console.log('scrollToTop69');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 71) {
                let scrollToTop = 950;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 1450;
                }

                console.log('scrollToTop71');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top: scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 73) {
                let scrollToTop = 1450;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2050;
                }

                console.log('scrollToTop73');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top:scrollToTop,
                  behavior: 'smooth'
                });
              }

              if (this.nowStep === 75) {
                console.log('nowStep 75');
                let scrollToTop = 1950;
                if(this.getGoalsObjective == 'MESSAGES'){
                  scrollToTop = 2550;
                }

                console.log('scrollToTop75');
                console.log(scrollToTop);

                this.$refs.scrollcontent.scrollTo({
                  top:scrollToTop,
                  behavior: 'smooth'
                });
              }
            }
          }
        }

        console.log('a event add nextStep');
        console.log(this.nowStep);
        console.log(this.postData);

        // let selectArticleLength = 0;

        // if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //   selectArticleLength = this.postData.select_article.length;
        // }

        if(overStep == 0 && this.nowStep != -1){
          // if(this.nowStep == 57 && selectArticleLength <= 0){
          //   this.nowStep = 56;
          //   this.$router.push({ query: { step: this.nowStep }});
          // } else {
            axios
              .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                id: this.teaching_id,
                campaign_id: this.db_campaign_id,
                campaign_objective: this.getGoalsObjective,
                skip: skip,
                step: this.nowStep,
                active: ''
              }))
              .then((response) => {
                if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                  this.teaching_id = response.data.id
                }
                // console.log(response);
                // if(response.data.status == 'success'){
                  // this.urlKeywords = response.data.return_data

                  // console.log(this.urlKeywords);
                // }
              });
          // }
        }
      },
      switchToOtherStep() {
        if (this.nowStep === 66) {
          this.nowStep = 67;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 1250,
            behavior: 'smooth'
          });
          // this.$refs.scrollcontent.scrollTo({
          //   top: 650,
          //   behavior: 'smooth'
          // });
        } else {
          this.nowStep = 64;
          this.$router.push({ query: { step: this.nowStep }});
          this.$refs.scrollcontent.scrollTo({
            top: 950,
            behavior: 'smooth'
          });
        }
      },
      closeTips() {
        console.log('closeTips');
        console.log(this.nowStep);

        let skip = 0;
        let skip_target = [0, 7, 13, 19, 28, 35, 40, 45, 51, 58, 75, 111];
        for(let i = 0; i < skip_target.length; i++){
          if(this.nowStep == skip_target[i]){
            skip = 1;
          } else if(this.nowStep == skip_target[i] && this.efficientAi == true){
            skip = 1;
          }
        }

        if(this.nowStep == 0 && skip == 1){
          this.targetAllSkip = 1;
        }

        console.log('targetAllSkip');
        console.log(this.targetAllSkip);
        // if(this.nowStep == 70){
        //   skip = 1;
        // }

        axios
          .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: this.teaching_id,
            campaign_id: this.db_campaign_id,
            campaign_objective: this.getGoalsObjective,
            skip: skip,
            step: this.nowStep,
            active: ''
          }))
          .then((response) => {
            if(response.data.teaching_status == 'Y'){
              this.targetTwoStatus = true
              this.targetThreeStatus = true
              this.teaching_id = 0;
            }

            if(response.data.id != null && response.data.id != '' && typeof response.data.id != 'undefined'){
                this.teaching_id = response.data.id
              }

            if(this.nowStep == 7){
              this.isAreadlyOpenShowTargetKW = true;
            }

            if(this.nowStep == 13){
              this.isAreadlyOpenshowTargetLA = true;
            }

            if(this.nowStep == 19 || (this.nowStep == 28 && this.efficientAi == true)){
              this.isAreadlyOpenshowGoalsAndBudget = true;
            }

            if(this.nowStep == 35){
              this.isAreadlyOpenshowRegions = true;
            }

            if(this.nowStep == 40){
              this.isAreadlyOpenshowRelationship = true;
            }

            if(this.nowStep == 45){
              this.isAreadlyOpenshowPositionAndDevice = true;
            }

            if(this.nowStep == 51){
              this.isAreadlyOpenshowMaterial = true;
            }

            if(this.nowStep == 58){
              this.isAreadlyOpenshowAdvertisingMaterial = true;
            }

            if(this.nowStep == 75){
              this.isAreadlyOpenshowFormMsg = true;
            }

            if(this.target == 3){
              this.targetThreeStatus = true;
            }

            if(this.nowStep === 66){
              this.nowStep = 75;
              this.$router.push({ query: { step: this.nowStep }});

              let scrollToTop = 1950;
              if(this.getGoalsObjective == 'MESSAGES'){
                scrollToTop = 2550;
              }

              this.$refs.scrollcontent.scrollTo({
                top:scrollToTop,
                behavior: 'smooth'
              });
            } else {
              this.nowStep = -1;
              this.openStep = 0;
              this.$router.push({ query: { step: this.nowStep }});
            }
          });
      },
      campaignNameEdit(type){
        console.log('campaignNameEdit');

        this.isEdit = type;
      },
      setAdvertisingMaterialType(type) {
        this.advertisingMaterialType = type;
      },
      openTeaching(value){
        console.log('openTeaching');

        axios
          .post('https://test.autoturn.net/inside/api/data/teaching_create.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            // console.log(response);
            // if(response.data.status == 'success'){
              // this.urlKeywords = response.data.return_data

              // console.log(this.urlKeywords);
            // }
            console.log('openTeaching response.data');
            console.log(response.data.id);
            console.log('openTeaching b this.nowStep');
            console.log(this.nowStep);
            console.log('openTeaching b this.teaching_id');
            console.log(this.teaching_id);
            this.nowStep = value;
            this.targetTwoStatus = false
            this.targetThreeStatus = false
            this.targetAllSkip = 0;

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            let get_value = '0_'+yearForm + monthForm + dateForm + timeForm;
            this.msgTeachingOver = get_value
            this.formTeachingOver = get_value

            this.teaching_id = response.data.id;
            console.log('openTeaching a this.msgTeachingOver');
            console.log(this.msgTeachingOver);
            console.log('openTeaching a this.nowStep');
            console.log(this.nowStep);
            console.log('openTeaching a this.teaching_id');
            console.log(this.teaching_id);
            this.$router.push({ query: { step: this.nowStep }});
            this.$refs.scrollcontent.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          });
      },
      // <!-- 新手教學 -->
      campaignNameEdit(type){
        // console.log('campaignNameEdit');

        this.isEdit = type;
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     this.Budget_KW_result = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      methodTargetKW(value){
        // console.log('methods childTargetKW')
        // console.log(value);
        this.showTargetKW = value
        // this.menu[0].submenu[1].show = value

        if(value == true){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, this.returnUseEndDate);

          //新手教學
          if(this.teaching_id != 0){
            if (!this.isAreadlyOpenShowTargetKW) {
              this.nowStep = 7;
              this.$router.push({ query: { step: this.nowStep }});

              setTimeout(()=> {
                this.$refs.scrollcontent.scrollTo({
                  top: 150,
                  behavior: 'smooth'
                });

              }, 1000);
            }
          }
          //新手教學
        } else {
          this.updateMinAddition = 0;
          this.urlKeywordsListData = [];
          this.keywordsSuggestListData = [];
        }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      methodTargetDM(value){
        // console.log('methods childTargetDM')
        // console.log(value);
        this.showTargetDM = value

        if(value == true){
          if(this.getGoalsObjective == 'CONVERSIONS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 65;
          }
          if(this.getGoalsObjective == 'LINK_CLICKS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(this.getGoalsObjective == 'POST_ENGAGEMENT'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(this.getGoalsObjective == 'VIDEO_VIEWS'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
          if(this.getGoalsObjective == 'LEAD_GENERATION'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 65;
          }
          if(this.getGoalsObjective == 'MESSAGES'){
            this.regionsData.age_min = 18;
            this.regionsData.age_max = 64;
          }
        }

        // console.log(this.regionsData);
      },
      methodTargetLA(value){
        // console.log('methods childTargetLA')
        // console.log(value);
        // this.showTargetLA = value
        // this.menu[0].submenu[2].show = value

        // if(value == true && this.lookData.custom_lookalikes == null){
        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

        //   this.showAdvertisingMix = get_value;
        //   console.log('b this.showAdvertisingMix');
        //   console.log(this.showAdvertisingMix);

        //   axios
        //     .post('https://test.autoturn.net/inside/api/campaign_lookalikes.php', Qs.stringify({
        //       s_code: this.$route.params.id,
        //       adaccount_id: this.$route.params.adaccount_id,
        //       pixel_id: this.goalsData.pixel_id,
        //       product_url: this.productUrl,
        //     }))
        //     .then((response) => {
        //       if(response.data.status == 'success'){

        //         this.lookData = {
        //                           default_lookalikes : response.data.return_data.default_lookalikes,
        //                           custom_lookalikes : response.data.return_data.custom_lookalikes,
        //                           custom_lookalikes_selected : response.data.return_data.custom_lookalikes_selected,
        //                           default_lookalikes_list : response.data.return_data.default_lookalikes_list,
        //                           custom_lookalikes_list : response.data.return_data.custom_lookalikes_list
        //                         }

        //         var todayForm = new Date();
        //         var yearForm = todayForm.getFullYear();
        //         var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //         var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //         var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //         let get_value = 'false_'+yearForm + monthForm + dateForm + timeForm;

        //         this.showAdvertisingMix = get_value;
        //         console.log('a this.showAdvertisingMix');
        //         console.log(this.showAdvertisingMix);

        //         //新手教學
        //         if(this.teaching_id != 0){
        //           if (!this.isAreadlyOpenshowTargetLA) {
        //             this.nowStep = 13;
        //             this.$router.push({ query: { step: this.nowStep }});

        //             let srollLA = 300;
        //             if(this.urlKeywordsListData.length > 0){
        //               srollLA = 450;
        //             }

        //             if(this.keywordsSuggestListData.length > 0){
        //               srollLA = 650;
        //             }

        //             setTimeout(()=> {
        //               this.$refs.scrollcontent.scrollTo({
        //                 top: srollLA,
        //                 behavior: 'smooth'
        //               });

        //             }, 1000);
        //           }
        //         }
        //         //新手教學
        //       }
        //     });
        // }

        // if(value != true && this.lookData.custom_lookalikes != null) {
        //   this.lookData = {
        //                     default_lookalikes : null,
        //                     custom_lookalikes : null,
        //                     custom_lookalikes_selected : null,
        //                     default_lookalikes_list : null,
        //                     custom_lookalikes_list : null
        //                   }
        // }

        // if(!this.menu[1].submenu[0].show && !this.menu[1].submenu[1].show){
        //   this.menu[1].show = false
        // } else {
        //   this.menu[1].show = true
        // }
      },
      // methodTargetCF(value){
      //   this.showTargetCF = value
      //   this.menu[0].submenu[4].show = value
      // },
      // methodTargetAD(value){
      //   console.log('methodTargetAD');
      //   console.log(value);

      //   this.efficientAi = value;

      //   this.dateData.end_date = '0000-00-00';
      //   console.log('this.dateData.end_date');
      //   console.log(this.dateData.end_date);
      // },
      methodBudgetKWTotal(value){
        // console.log('methodBudgetKWTotal:'+value);
        // console.log('b this.budgetKW:'+this.budgetKW);
        this.budgetKW = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, this.returnGapTime, value, this.returnUseEndDate);
        }

        // console.log('a this.budgetKW:'+this.budgetKW);
      },
      dateGapTime(value){
        // console.log('dateGapTime:'+value);
        // console.log('b this.returnGapTime:'+this.returnGapTime);
        this.returnGapTime = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, value, this.budgetKW, this.returnUseEndDate);
        }

        // console.log('a this.returnGapTime:'+this.returnGapTime);
      },
      dateEndTime(value){
        // console.log('dateEndTime:'+value);
        // console.log('b this.returnEndTime:'+this.returnEndTime);
        this.returnEndTime = value;

        let startTime = this.dateData.start_date;
        let diffType = 'day';
        let gapTime = 0;

        if(startTime != '' && startTime != '0000-00-00' && startTime != null && value != '' && value != '0000-00-00' && value != null){
          diffType = diffType.toLowerCase();
          var sTime =new Date(startTime); //開始時間
          var eTime =new Date(value); //結束時間
          //作為除數的數字
          var timeType = 1;
          switch (diffType) {
              case"second":
                  timeType =1000;
              break;
              case"minute":
                  timeType =1000*60;
              break;
              case"hour":
                  timeType =1000*3600;
              break;
              case"day":
                  timeType =1000*3600*24;
              break;
              default:
              break;
          }
          gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
        }

        this.returnGapTime = gapTime;

        this.minAddition(this.goalsData.form_addition, gapTime, this.budgetKW, this.returnUseEndDate);

        // console.log('a this.returnEndTime:'+this.returnEndTime);
      },
      dateUseEndDate(value){
        // console.log('dateUseEndDate:'+value);
        // console.log('b this.returnUseEndDate:'+this.returnUseEndDate);
        this.returnUseEndDate = value

        this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, value);

        // console.log('a this.returnUseEndDate:'+this.returnUseEndDate);
      },
      goalsObjective(value){
        // console.log('goalsObjective')
        // console.log(value);

        // this.getGoalsObjective = value

        // if(this.showTargetDM == true){
        //   // if(value == 'CONVERSIONS'){
        //   //   this.regionsData.age_min = 13;
        //   //   this.regionsData.age_max = 65;
        //   // }
        //   // if(value == 'LINK_CLICKS'){
        //   //   this.regionsData.age_min = 13;
        //   //   this.regionsData.age_max = 64;
        //   // }
        //   // if(value == 'POST_ENGAGEMENT'){
        //   //   this.regionsData.age_min = 13;
        //   //   this.regionsData.age_max = 64;
        //   // }
        //   // if(value == 'VIDEO_VIEWS'){
        //   //   this.regionsData.age_min = 13;
        //   //   this.regionsData.age_max = 64;
        //   // }
        //   // if(value == 'LEAD_GENERATION'){
        //   //   this.regionsData.age_min = 18;
        //   //   this.regionsData.age_max = 65;
        //   // }
        //   // if(value == 'MESSAGES'){
        //   //   this.regionsData.age_min = 13;
        //   //   this.regionsData.age_max = 64;
        //   // }

        //   this.regionsData.age_min = 18;
        //   this.regionsData.age_max = 65;
        // }

        // if(value == 'CONVERSIONS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialDataNew.creative_array = []
        // }
        // if(value == 'LINK_CLICKS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialDataNew.creative_array = []
        // }
        // if(value == 'POST_ENGAGEMENT'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialDataNew.creative_array = []
        // }
        // if(value == 'VIDEO_VIEWS'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.adMaterialDataNew.creative_array = []
        // }
        // if(value == 'LEAD_GENERATION'){
        //   this.showMaterial = false;
        //   this.showAdvertisingMaterial = true;
        //   this.showForm = true;
        //   this.showMsg = false;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }
        // if(value == 'MESSAGES'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   // if(this.adMaterialData.creative_array == null){
        //   //   this.adMaterialData.creative_array = [
        //   //     {
        //   //       title: "xxxx",
        //   //       isEdit: false,
        //   //       type: 1,
        //   //       materials:[],
        //   //       materialSingle: [
        //   //         {
        //   //           src: null,
        //   //           title: null,
        //   //           size: null
        //   //         }
        //   //       ],
        //   //       callActive: 'SIGN_UP'
        //   //     }
        //   //   ]
        //   // }
        // }

        // if(value == 'PRODUCT_CATALOG_SALES'){
        //   this.showMaterial = true;
        //   this.showAdvertisingMaterial = false;
        //   this.showForm = false;
        //   this.showMsg = false;

        //   this.postData.select_article = [];
        //   this.postData.select_creatives = [];
        // } else {
        //   this.postData.select_creatives_adset_ads = [];
        // }

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);
      },
      objectiveOption(value){
        if(value != '' && value != null && typeof value != 'undefined'){
          let objectiveOptionValue = value.split("|");

          // console.log('objectiveOption');
          // console.log(objectiveOptionValue);
          // console.log(this.formPixelId);

          this.formPixelId = objectiveOptionValue[0]

          // console.log(this.formPixelId);
        }
      },
      keywordUrl(value){
        // console.log('keywordUrl')
        // console.log(value);

        this.productUrl = value
      },
      childSelectedCategories(value){
        this.keywordsSelectedCategories = value;
      },
      childReturnKeywords(value){
        this.returnKeywordsList = value;
      },
      childNoTiktok(value){
        this.noTiktokStatus = value;
      },
      urlKeywordsList(value){
        console.log('urlKeywordsList');
        console.log(value);
        console.log(value.length);

        this.urlKeywordsListData = value
      },
      keywordsSuggestList(value){
        this.keywordsSuggestListData = value
      },
      getHere(target, click){
        this.changeYoutubeType();

        console.log('getHere');
        console.log('this.target');
        console.log(this.target);

        console.log('target');
        console.log(target);

        if(click == 1){
          this.target = target

          // if(this.menu[1].show == false){
          //   if (target > 1) {
          //     target -= 1
          //   }
          //   this.process = parseInt(33) * (parseInt(target) - parseInt(1))
          // } else {
          //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
          // }

          this.process = parseInt(33) * (parseInt(target) - parseInt(1))

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
        // console.log('methods eventFormId')
        // console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        // console.log('methods eventMessageId')
        // console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      adMaterialContent(value){
        // console.log('adMaterialContent')
        // console.log(value);

        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        console.log('b this.changeFormId')
        console.log(this.changeFormId);

        this.changeFormId = null

        console.log('c this.changeFormId')
        console.log(this.changeFormId);

        this.changeFormId = value

        console.log('a this.changeFormId')
        console.log(this.changeFormId);
      },
      formChangeMessageId(value){
        // console.log('formChangeMessageId')
        // console.log(value);

        // his.changeMessageId = null
        this.changeMessageId = value
      },
      activeScroll(value){

        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.AdvertisingMaterialStatus = this.showMsg;

          // console.log('activeScroll');
          // console.log('this.showAdvertisingMaterial');
          // console.log(this.showAdvertisingMaterial);
          // console.log('this.showMsg');
          // console.log(this.showMsg);

          // this.$refs.scrollcontent.scrollTo({
          //   top: 1505,
          //   behavior: 'smooth'
          // });
        }
      },
      formMsgTeachingOver(value){
        console.log('formMsgTeachingOver');
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = '1_'+yearForm + monthForm + dateForm + timeForm;

        this.msgTeachingOver = get_value
        console.log('this.msgTeachingOver');
        console.log(this.msgTeachingOver);
      },
      activeFormTeachingOver(value){
        console.log('activeFormTeachingOver');
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = '1_'+yearForm + monthForm + dateForm + timeForm;

        this.formTeachingOver = get_value
        console.log('this.formTeachingOver');
        console.log(this.formTeachingOver);
      },
      prev() {
        this.changeYoutubeType();
        // console.log('now target:'+this.target);
        // let isTrue = 1;

        // if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
        //   Swal.fire(
        //                 "行銷活動名稱",
        //                 "請填寫行銷活動名稱",
        //                 "error"
        //               )
        //   isTrue = 0;
        // }

        // if(this.target == 2){
        //   if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
        //     if(this.keywordData.select_keywords.length > 0 && this.methodData.Target_KW == true){
        //       let select_keywords_num = 0;
        //       for (var i = 0; i >= this.keywordData.select_keywords.length; i++) {
        //         if(this.keywordData.select_keywords.checked == true){
        //           select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
        //         }
        //       }

        //       if(select_keywords_num > 5){
        //         Swal.fire(
        //                 "精準興趣廣告組合與關鍵字",
        //                 "關鍵字最多選擇5個",
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     }
        //   } else {
        //     Swal.fire(
        //               "精準興趣廣告組合與關鍵字",
        //               "關鍵字最多選擇5個",
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.methodData.Target_LA == true){
        //     if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
        //       let lookalikes_num = 0;
        //       for (var i = 0; i >= this.lookData.default_lookalikes_list.length; i++) {
        //         console.log('checked type:'+typeof this.lookData.default_lookalikes_list.checked);
        //         if(this.lookData.default_lookalikes_list.checked == true){
        //           lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //         }
        //       }

        //       console.log(this.lookData.default_lookalikes_list);
        //       console.log('default_lookalikes_list');
        //       console.log(lookalikes_num);

        //       for (var i = 0; i >= this.lookData.custom_lookalikes_selected.length; i++) {
        //         lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //       }

        //       console.log(this.lookData.custom_lookalikes_selected);
        //       console.log('custom_lookalikes_selected');
        //       console.log(lookalikes_num);

        //       if(lookalikes_num != 5){
        //         Swal.fire(
        //                 "類似受眾廣告組合",
        //                 "自訂類似受眾與預設類似受眾，總共需選擇5個",
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     } else {
        //       Swal.fire(
        //               "類似受眾廣告組合",
        //               "自訂類似受眾與預設類似受眾，總共需選擇5個",
        //               "error"
        //             )
        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 3){
        //   console.log('objective_option:'+this.goalsData.objective_option);
        //   console.log('conversion_domain:'+this.goalsData.conversion_domain);
        //   console.log('risk_level:'+this.goalsData.risk_level.code);
        //   console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
        //   if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
        //     Swal.fire(
        //             "行銷活動目標",
        //             "請選擇一個行銷活動目標與條件",
        //             "error"
        //           )
        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
        //     Swal.fire(
        //               "行銷活動目標",
        //               "若選擇「轉換次數」，就必須設定「轉換網域」",
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
        //     Swal.fire(
        //               "目標成本與預算使用",
        //               "如預算使用設定為「自動」或「保守」，則必須設定目標成本",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
        //     let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
        //     let custom_excluded_audiences_selected_num = 0;
        //     for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
        //       if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
        //         custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
        //       }
        //     }

        //     let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

        //     if(excluded_audiences_num > 5){
        //       Swal.fire(
        //                 "排除受眾",
        //                 "最多設定5個",
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 4){
        //   if(this.pdData.auto_publisher == false && (this.pdData.publisher_platforms.length <= 0 || this.pdData.publisher_platforms == '' || this.pdData.publisher_platforms == null || typeof this.pdData.publisher_platforms == 'undefined')){
        //     Swal.fire(
        //               "版位與裝置",
        //               "請至少設定一種版位。",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.idData.page_id == '' || this.idData.page_id == null || typeof this.idData.page_id == 'undefined'){
        //     Swal.fire(
        //               "Facebook",
        //               "請選擇一個Facebook粉絲專頁。",
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' || this.goalsData.campaign_objective == 'LINK_CLICKS' || this.goalsData.campaign_objective == 'POST_ENGAGEMENT' || this.goalsData.campaign_objective == 'VIDEO_VIEWS'){
        //     if(this.postData.select_article.length <= 0){
        //       isTrue = 1;

        //       Swal.fire(
        //         '確認修改',
        //         '請選擇一篇貼文。',
        //         'error'
        //       )
        //     }
        //   }

        //   if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
        //     if(this.adMaterialData.creative_array.length <= 0){
        //       isTrue = 1;

        //       Swal.fire(
        //         '確認修改',
        //         '請設定一組廣告素材。',
        //         'error'
        //       )
        //     }
        //   }
        // }

        // if(isTrue == 1){
          let member_hash = this.$route.params.id
          let advertiser_id = this.$route.params.adaccount_id

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'add',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    }

                    if (result.dismiss === Swal.DismissReason.timer) {
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }

                    if (result.dismiss === Swal.DismissReason.timer) {
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if(this.menu[1].show == false){
                    this.process -= 33
                    if (this.target > 1) {
                      this.target -= 1

                      // if(this.target == 2){
                      //   this.target -= 1
                      // }
                    }
                  // } else {
                  //   this.process -= 25
                  //   if (this.target > 1) {
                  //     this.target -= 1
                  //   }
                  // }
                  // console.log('prev target:'+this.target);
                  document.getElementById('edit_content').scrollTop = 0;

                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    axios
                      .post('https://test.autoturn.net/inside/api/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          axios
                            .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              id: this.teaching_id,
                              campaign_id: this.db_campaign_id,
                              campaign_objective: '',
                              skip: '',
                              step: '',
                              active: 'campaign_id'
                            }));
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_add_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_add_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        target: 'add_prev_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          // Swal.fire({
                          //   icon: 'success',
                          //   title: '儲存',
                          //   text: response.data.info,
                          //   showDenyButton: false,
                          //   showCancelButton: false,
                          //   confirmButtonText: '確定',
                          //   // denyButtonText: `Don't save`,
                          // }).then((result) => {
                          //   if (result.isConfirmed) {
                          //     // Swal.fire('Saved!', '', 'success')

                          //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          //   } else if (result.isDenied) {
                          //     // Swal.fire('Changes are not saved', '', 'info')
                          //   }
                          // })

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['warning']['campaign_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                // if(this.menu[1].show == false){
                  this.process -= 33
                  if (this.target > 1) {
                    this.target -= 1

                    // if(this.target == 2){
                    //   this.target -= 1
                    // }
                  }
                // } else {
                //   this.process -= 25
                //   if (this.target > 1) {
                //     this.target -= 1
                //   }
                // }
                // console.log('prev target:'+this.target);
                document.getElementById('edit_content').scrollTop = 0;

                if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  axios
                    .post('https://test.autoturn.net/inside/api/data/campaign_add_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);

                      if(response.data.status == 'success'){
                        this.db_campaign_id = response.data.campaign_id
                        axios
                          .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            id: this.teaching_id,
                            campaign_id: this.db_campaign_id,
                            campaign_objective: '',
                            skip: '',
                            step: '',
                            active: 'campaign_id'
                          }));
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_add_update']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_add_update']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                } else {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                      target: 'add_prev_'+this.target,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        // Swal.fire({
                        //   icon: 'success',
                        //   title: '儲存',
                        //   text: response.data.info,
                        //   showDenyButton: false,
                        //   showCancelButton: false,
                        //   confirmButtonText: '確定',
                        //   // denyButtonText: `Don't save`,
                        // }).then((result) => {
                        //   if (result.isConfirmed) {
                        //     // Swal.fire('Saved!', '', 'success')

                        //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                        //   } else if (result.isDenied) {
                        //     // Swal.fire('Changes are not saved', '', 'info')
                        //   }
                        // })

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_update']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_add_update']['success']['campaign_update']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['prev']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        // }
      },
      next() {
        console.log('this.methodData');
        console.log(this.methodData);

        // console.log('b #1 this.target');
        // console.log(this.target);

        // if(this.process < 66){
        //   this.process += 33
        //   // console.log('now target:'+this.target);
        //   if (this.target <= 3) {
        //     this.target += 1
        //     this.menu[this.target-1].open = true
        //     this.menu[this.target-1].click = 1
        //   }
        //   // if(this.target == 2){
        //   //   this.target += 1
        //   // }
        // }

        // console.log('a #1 this.target');
        // console.log(this.target);

        // this.changeYoutubeType();

        // if (this.target === 3 && this.campaign_name === this.originName && !this.isAlreadyShowNameTips) {
        //   this.nowStep = 888;
        //   this.$router.push({ query: { step: this.nowStep }});
        //   this.isAlreadyShowNameTips = true;
        //   return;
        // }
        // console.log('now target:'+this.target);
        let isTrue = 1;

        console.log('this.campaign_name');
        console.log(this.campaign_name);

        if(this.advertiser_id == null || this.advertiser_id == '' || typeof this.advertiser_id == 'undefined'){
          Swal.fire({
            icon: 'error',
            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_swal_title'],
            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_adaccount_id_confirm_button']
            // denyButtonText: `Don't save`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Swal.fire('Saved!', '', 'success')
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
            } else if (result.isDenied) {
              // Swal.fire('Changes are not saved', '', 'info')
              this.allPageLoading = true
              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
            }
          })

          isTrue = 0;
        }

        if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
          Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_campaign_name_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_campaign_name_swal_text'],
                        "error"
                      )
          isTrue = 0;
        }

        if(this.methodData.Budget_KW == ''){
          Swal.fire(
                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_title'],
                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_text'],
                    "error"
                  )
          isTrue = 0;
        }

        console.log('creator_action_categories');
        console.log(this.keywordData.creator_action_categories.length);
        console.log('interest_categories');
        console.log(this.keywordData.interest_categories.length);
        console.log('video_action_categories');
        console.log(this.keywordData.video_action_categories.length);
        console.log('interest_keywords');
        console.log(this.keywordData.interest_keywords.length);
        console.log('hashtags');
        console.log(this.keywordData.hashtags.length);

        let creator_action_categories_length = this.keywordData.creator_action_categories.length;
        let interest_categories_length = this.keywordData.interest_categories.length;
        let video_action_categories_length = this.keywordData.video_action_categories.length;
        let interest_keywords_length = this.keywordData.interest_keywords.length;
        let hashtags_length = this.keywordData.hashtags.length;
        let select_keywords_num = 0;

        select_keywords_num = parseInt(creator_action_categories_length) + parseInt(interest_categories_length) +parseInt(video_action_categories_length) + parseInt(interest_keywords_length) + parseInt(hashtags_length);

        if(select_keywords_num != 5){
          console.log('11');
          Swal.fire(
                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['select_keywords_limit_swal_text'],
                  "error"
                )
          isTrue = 0;
        }

        console.log('this.dateData');
        console.log(this.dateData);

        if(this.dateData.use_end_date == false && this.dateData.end_date == '0000-00-00'){
          Swal.fire(
                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_date_swal_title'],
                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_date_swal_text'],
                  "error"
                )
          isTrue = 0;
        }

        if(this.target == 2){
          if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
            Swal.fire(
                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_title'],
                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_text'],
                    "error"
                  )
            isTrue = 0;
          }

          if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_text'],
                      "error"
                    )

            isTrue = 0;
          }

          if(this.regionsData.locations_selected == '' || this.regionsData.locations_selected == 0 || this.regionsData.locations_selected == null){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_locations_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_locations_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }

          if(this.regionsData.age_groups.length <= 0){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_age_groups_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_age_groups_swal_text'],
                      "error"
                    )

            isTrue = 0;
          }
        }

        if(this.target == 3){
          if(this.pdData.placement_type == 'PLACEMENT_TYPE_NORMAL'){
            if(this.pdData.placements != null && this.pdData.placements != '' && typeof this.pdData.placements != 'undefined'){
              if(this.pdData.placements.length <= 0){
                Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_placements_swal_title'],
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_placements_swal_text'],
                          "error"
                        )

                isTrue = 0;
              }
            } else {
              Swal.fire(
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_placements_swal_title'],
                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_placements_swal_text'],
                        "error"
                      )

              isTrue = 0;
            }
          }

          if(this.idData.identity_id == '' || this.idData.identity_id == 0 || this.idData.identity_id == null){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_identity_id_swal_title'],
                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_identity_id_swal_text'],
                      "error"
                    )

            isTrue = 0;
          }


          let caption_format = 0;
          let caption = 0;
          let message = 0;
          let single_object_spec = 0;
          let title = 0;

          console.log('this.adMaterialData');
          console.log(this.adMaterialData);
          console.log('this.adMaterialDataNew');
          console.log(this.adMaterialDataNew);

          let creative_array_length = this.adMaterialDataNew.creative_array.length;
          console.log(creative_array_length);

          if(creative_array_length > 0){
            console.log('have creative_array_length');
            for(let i = 0; i < creative_array_length; i++){
              console.log(this.adMaterialDataNew.creative_array[i].caption);
              const regex = /^(http:\/\/|https:\/\/)/;

              if (!regex.test(this.adMaterialDataNew.creative_array[i].caption)) {
                caption_format = 1;
              }

              if(this.adMaterialDataNew.creative_array[i].caption == '' || this.adMaterialDataNew.creative_array[i].caption == null || typeof this.adMaterialDataNew.creative_array[i].caption == 'undefined'){
                caption = 1;
              }

              console.log(this.adMaterialDataNew.creative_array[i].message);

              if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                message = 1;
              }

              console.log(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id);

              if(this.adMaterialDataNew.creative_array[i].type == 1){
                if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.video_id == 'undefined'){
                  single_object_spec = 1;
                }
              }

              console.log(this.adMaterialDataNew.creative_array[i].title);

              if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                title = 1;
              }
            }

            if(caption_format == 1){
              isTrue = 0;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_target_url_swal_title'],
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_target_url_format_swal_text'],
                'error'
              );
            }

            if(caption == 1){
              isTrue = 0;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_target_url_swal_title'],
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_target_url_swal_text'],
                'error'
              );
            }

            if(message == 1){
              isTrue = 0;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_ad_content_swal_title'],
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_ad_content_swal_text'],
                'error'
              );
            }

            if(single_object_spec == 1){
              isTrue = 0;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_audio_video_swal_title'],
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_audio_video_swal_text'],
                'error'
              );
            }

            if(title == 1){
              isTrue = 0;

              Swal.fire(
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_ad_name_swal_title'],
                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_ad_name_swal_text'],
                'error'
              );
            }
          } else {
            isTrue = 0;

            console.log('empty_material_swal_title');
            console.log(this.showLang[this.selectLang]);
            console.log(this.showLang[this.selectLang]['views']);
            console.log(this.showLang[this.selectLang]['views']['EventAdd']);
            console.log(this.showLang[this.selectLang]['views']['EventAdd']['methods']);
            console.log(this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']);

            Swal.fire(
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_swal_title'],
              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_material_swal_text'],
              'error'
            );
          }
        }

        console.log('isTrue:', isTrue);

        // if(this.target == 1 || this.target == 3){
        //   if(this.methodData.Target_KW == false && this.methodData.Target_DM == false && this.methodData.Target_LA == false && this.methodData.Target_RT == false && this.methodData.Target_CF == false && this.methodData.Target_AD == false){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_kw_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_kw_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if((this.methodData.Target_KW == true && this.methodData.Budget_KW == '') || (this.methodData.Target_DM == true && this.methodData.Budget_DM == '') || (this.methodData.Target_LA == true && this.methodData.Budget_LA == '') || (this.methodData.Target_RT == true && this.methodData.Budget_RT == '') || (this.methodData.Target_CF == true && this.methodData.Budget_CF == '')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_kw_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.methodData.Target_RT == true && (this.methodData.retargeting == '' || this.methodData.retargeting == [])){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_target_rt_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_budget_rt_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.methodData.Target_AD == true){
        //     if(this.methodData.Budget_AD_min != '' && this.methodData.Budget_AD_min != null && typeof this.methodData.Budget_AD_min != 'undefined' && this.methodData.Budget_AD_max != '' && this.methodData.Budget_AD_max != null && typeof this.methodData.Budget_AD_max != 'undefined' && parseInt(this.methodData.Budget_AD_min) >= parseInt(this.methodData.Budget_AD_max)){

        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_1'],
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }

        //     if(parseInt(this.methodData.Budget_AD_min) == 0 || this.methodData.Budget_AD_min == '' || this.methodData.Budget_AD_min == null || typeof this.methodData.Budget_AD_min == 'undefined'){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_2'],
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }

        //     if(parseInt(this.methodData.Budget_AD_max) == 0 || this.methodData.Budget_AD_max == '' || this.methodData.Budget_AD_max == null || typeof this.methodData.Budget_AD_max == 'undefined'){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_swal_text_3'],
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }

        //   if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
        //     let startTime = this.dateData.start_date;
        //     let endTime = this.dateData.end_date;

        //     var sTime = new Date(startTime); //開始時間
        //     var eTime = new Date(endTime); //結束時間

        //     if(sTime > eTime){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_start_date_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_start_date_swal_text'],
        //                 "error"
        //               )
        //       isTrue = 0;
        //     }
        //   }

        //   // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

        //   if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_end_date_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_end_date_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }
        // }

        // if(this.target == 1 || this.target == 3){
        //   if(this.methodData.Target_KW == true){
        //     if(this.keywordData.select_keywords != '' && this.keywordData.select_keywords != null && typeof this.keywordData.select_keywords != 'undefined'){
        //       if(this.keywordData.select_keywords.length > 0 && this.methodData.Target_KW == true){
        //         let select_keywords_num = 0;
        //         for (var i = 0; i >= this.keywordData.select_keywords.length; i++) {
        //           if(this.keywordData.select_keywords.checked == true){
        //             select_keywords_num = parseInt(select_keywords_num) + parseInt(1);
        //           }
        //         }

        //         if(select_keywords_num > 5){
        //           // console.log('11');
        //           Swal.fire(
        //                   this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
        //                   this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_text'],
        //                   "error"
        //                 )
        //           isTrue = 0;
        //         }
        //       }
        //     } else {
        //       // console.log('22');
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_select_keywords_swal_text'],
        //                 "error"
        //               )
        //       isTrue = 0;
        //     }
        //   }

        //   if(this.methodData.Target_LA == true){
        //     // console.log('this.lookData.default_lookalikes_list');
        //     // console.log(this.lookData.default_lookalikes_list);
        //     // console.log('this.lookData.custom_lookalikes_selected');
        //     // console.log(this.lookData.custom_lookalikes_selected);
        //     // console.log('this.lookData.custom_lookalikes_selected.length');
        //     // console.log(this.lookData.custom_lookalikes_selected.length);
        //     if((this.lookData.default_lookalikes_list != '' && this.lookData.default_lookalikes_list != null && typeof this.lookData.default_lookalikes_list != 'undefined') || (this.lookData.custom_lookalikes_selected != '' && this.lookData.custom_lookalikes_selected != null && typeof this.lookData.custom_lookalikes_selected != 'undefined')){
        //       let lookalikes_num = 0;
        //       if(this.lookData.default_lookalikes_list.length > 0){
        //         for (var i = 0; i < this.lookData.default_lookalikes_list.length; i++) {
        //           // console.log('i1:'+i);
        //           if(this.lookData.default_lookalikes_list[i].checked == true){
        //             lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //           }
        //         }
        //       }

        //       if(this.lookData.custom_lookalikes_selected.length > 0){
        //         for (var i = 0; i < this.lookData.custom_lookalikes_selected.length; i++) {
        //           // console.log('i2:'+i);
        //           lookalikes_num = parseInt(lookalikes_num) + parseInt(1);
        //         }
        //       }

        //       if(lookalikes_num != 5){
        //         // console.log('33');
        //         Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_text'],
        //                 "error"
        //               )
        //         isTrue = 0;
        //       }
        //     } else {
        //       // console.log('44');
        //       Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_lookalikes_list_swal_text'],
        //               "error"
        //             )
        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 2){
        //   // console.log('this.goalsData');
        //   // console.log(this.goalsData);
        //   // console.log('objective_option:'+this.goalsData.objective_option);
        //   // console.log('conversion_domain:'+this.goalsData.conversion_domain);
        //   // console.log('risk_level:'+this.goalsData.risk_level.code);
        //   // console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
        //   if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
        //     Swal.fire(
        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_title'],
        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_objective_option_swal_text'],
        //             "error"
        //           )
        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_conversion_domain_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_conversion_domain_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   let event_text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['product_datalog_sales_default_event_text'];
        //   if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
        //     event_text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_default_event_text'];
        //   }

        //   if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
        //               event_text,
        //               "warning"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
        //     if(this.goalsData.product_set_id == '' || this.goalsData.product_set_id == null || typeof this.goalsData.product_set_id == 'undefined'){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_set_id_event_text'],
        //                 "warning"
        //               )

        //       isTrue = 0;
        //     }

        //     if(this.goalsData.product_catalog_id == '' || this.goalsData.product_catalog_id == null || typeof this.goalsData.product_catalog_id == 'undefined'){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_product_catalog_sales_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['is_product_datalog_sales_catalog_id_event_text'],
        //                 "warning"
        //               )

        //       isTrue = 0;
        //     }
        //   }

        //   if(this.methodData.Target_AD == true){
        //     if(this.goalsData.effect == '' || this.goalsData.effect == null || typeof this.goalsData.effect == 'undefined'){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_not_effect_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['efficient_ai_not_effect_swal_text'],
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }

        //   if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_effect_swal_text'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.exAudiencesData.excluded_audiences != '' && this.exAudiencesData.excluded_audiences != null && typeof this.exAudiencesData.excluded_audiences != 'undefined' ){
        //     let excluded_audiences = this.exAudiencesData.excluded_audiences.length;
        //     let custom_excluded_audiences_selected_num = 0;
        //     if(this.exAudiencesData.custom_excluded_audiences_selected.length > 0){
        //       for (var i = 0; i >= this.exAudiencesData.custom_excluded_audiences_selected.length; i++) {
        //         if(this.exAudiencesData.custom_excluded_audiences_selected.checked == true){
        //           custom_excluded_audiences_selected_num = parseInt(custom_excluded_audiences_selected_num) + parseInt(1);
        //         }
        //       }
        //     }

        //     let excluded_audiences_num = parseInt(excluded_audiences) + parseInt(custom_excluded_audiences_selected_num);

        //     if(excluded_audiences_num > 10){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_excluded_audiences_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['empty_excluded_audiences_swal_text'],
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }

        //   if(this.methodData.Target_AD == true){
        //     let _default_Budget_AD_max = Math.trunc(parseInt(this.goalsData.effect) * parseInt(10));
        //     if(_default_Budget_AD_max > this.methodData.Budget_AD_max){
        //       Swal.fire(
        //                 '目標成本',
        //                 '預算上限要大於目標成本 10 倍。',
        //                 "error"
        //               )

        //       isTrue = 0;
        //     }
        //   }
        // }

        // if(this.target == 3){
        //   let selectArticleLength = 0;
        //   if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //     selectArticleLength = this.postData.select_article.length;
        //   }

        //   let selectCreativesLength = 0;
        //   if(this.postData.select_creatives != '' && this.postData.select_creatives != null && typeof this.postData.select_creatives != 'undefined'){
        //     selectCreativesLength = this.postData.select_creatives.length;
        //   }

        //   let creativeArrayLength = 0;
        //   if(this.postData.select_creatives_adset_ads != '' && this.postData.select_creatives_adset_ads != null && typeof this.postData.select_creatives_adset_ads != 'undefined'){
        //     creativeArrayLength = this.postData.select_creatives_adset_ads.length;
        //   }

        //   console.log('this.postData');
        //   console.log(this.postData);
        //   console.log('this.adMaterialDataNew');
        //   console.log(this.adMaterialDataNew);

        //   let numMaterial = parseInt(selectArticleLength) + parseInt(selectCreativesLength) + parseInt(creativeArrayLength);
        //   let _default_Budget_AD_mim = parseInt(numMaterial) * parseInt(this.goalsData.effect);
        //   console.log('this.goalsData.effect');
        //   console.log(this.goalsData.effect);
        //   console.log('numMaterial');
        //   console.log(numMaterial);
        //   console.log('_default_Budget_AD_mim');
        //   console.log(_default_Budget_AD_mim);
        //   if(parseInt(this.methodData.Budget_AD_min) < _default_Budget_AD_mim){
        //     Swal.fire(
        //               '素材設定',
        //               '預算下限要大於 '+_default_Budget_AD_mim,
        //               "error"
        //             )

        //     isTrue = 0;
        //   }
        // }

        if(isTrue == 1){
          // console.log('000發佈 this.target');
          // console.log(this.target);
          let member_hash = this.$route.params.id
          let advertiser_id = this.$route.params.adaccount_id

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'add',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    console.log(this.goalsData);
                    console.log(this.exAudiencesData);
                    console.log(_tmp_goalsData);
                    console.log(_tmp_exAudiencesData);

                    console.log('======b');

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    console.log('======a');

                    console.log(this.goalsData);
                    console.log(this.exAudiencesData);
                    console.log(_tmp_goalsData);
                    console.log(_tmp_exAudiencesData);

                    let formData = {
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    console.log('#1 campaign_add_update');

                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          // axios
                          //   .post('https://test.autoturn.net/inside/api/tiktok/data/teaching_update.php', Qs.stringify({
                          //     s_code: this.$route.params.id,
                          //     id: this.teaching_id,
                          //     campaign_id: this.db_campaign_id,
                          //     campaign_objective: '',
                          //     skip: '',
                          //     step: '',
                          //     active: 'campaign_id'
                          //   }));

                          // console.log('333111發佈 this.target');
                          // console.log(this.target);

                          // if(this.menu[1].show == false){
                          console.log('b #2 this.target');
                          console.log(this.target);
                            if(this.process < 66){
                              this.process += 33
                              // console.log('now target:'+this.target);
                              if (this.target <= 3) {
                                this.target += 1
                                this.menu[this.target-1].open = true
                                this.menu[this.target-1].click = 1
                              }
                              // if(this.target == 2){
                              //   this.target += 1
                              // }
                            }
                          console.log('a #2 this.target');
                          console.log(this.target);
                          // } else {
                          //   if(this.process < 75){
                          //     this.process += 25
                          //     // console.log('now target:'+this.target);
                          //     if (this.target <= 4) {
                          //       this.target += 1
                          //       this.menu[this.target-1].open = true
                          //       this.menu[this.target-1].click = 1
                          //     }
                          //     // console.log('next target:'+this.target);
                          //   }
                          // }
                          // console.log('next target:'+this.target);
                          document.getElementById('edit_content').scrollTop = 0;
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    let type = '';
                    if(this.target == 3){
                      type = 'release';
                    }

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      if(this.target == 3){
                        let materialType = 0;
                        let selectArticleLength = 0;
                        if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                          selectArticleLength = this.postData.select_article.length;
                        }

                        let selectCreativesMessageLength = 0;
                        if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                          selectCreativesMessageLength = this.postData.select_creatives_message.length;
                        }

                        let creativeArrayLength = 0;
                        if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                          creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                        }

                        if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          materialType = 1;
                        } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                          materialType = 2;
                        }

                        console.log('#1 materialType:'+materialType);

                        if(materialType == 0){
                          // console.log('#2');
                          let message_sr_i = 0;
                          let form_sr_i = 0;
                          let message = 0;
                          let single_object_spec = 0;
                          let single_title = 0;
                          let materials_item = 0;
                          let materials_object_spec = 0;
                          let materials_title = 0;
                          let ad_name = 0;

                          for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                            if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                              ad_name = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].type == 2){
                              let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                              if(materials_length < 2){
                                materials_item = 1;
                              } else {
                                for(let j = 0; j < materials_length; j++){
                                  if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                    materials_object_spec = 1;
                                  }

                                  if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                    materials_title = 1;
                                  }
                                }
                              }
                            }

                            if(this.adMaterialDataNew.creative_array[i].type == 1){
                              if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                                single_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                                single_title = 1;
                              }
                            }

                            if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                              message = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                              form_sr_i = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                              message_sr_i = 1;
                            }
                          }

                          if(ad_name == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_ad_name_swal_text'],
                                        "error"
                                      )
                          } else if(single_object_spec == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_single_object_spec_swal_text'],
                                        "error"
                                      )
                          } else if(single_title == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_single_title_swal_text'],
                                        "error"
                                      )
                          } else if(materials_item == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_item_swal_text'],
                                        "error"
                                      )
                          } else if(materials_object_spec == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_object_spec_swal_text'],
                                        "error"
                                      )
                          } else if(materials_title == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_materials_title_swal_text'],
                                        "error"
                                      )
                          } else if(message == 1){
                            Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_message_swal_text'],
                                        "error"
                                      )
                          } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                            Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_form_sr_i_swal_text'],
                                      "error"
                                    )
                          } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                            Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_message_sr_i_swal_text'],
                                      "error"
                                    )
                          } else {
                            // console.log('#5');
                            axios
                              .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                                s_code: this.$route.params.id,
                                form_data: formData,
                                type: type,
                                target: 'add_next_'+this.target,
                              }))
                              .then((response) => {
                                // console.log(response.data);
                                if(response.data.status == 'success'){
                                  // this.immediateList = response.data.return_data
                                  // this.formData = response.data.return_data.form

                                  // Swal.fire({
                                  //   icon: 'success',
                                  //   title: '儲存',
                                  //   text: response.data.info,
                                  //   showDenyButton: false,
                                  //   showCancelButton: false,
                                  //   confirmButtonText: '確定',
                                  //   // denyButtonText: `Don't save`,
                                  // }).then((result) => {
                                  //   if (result.isConfirmed) {
                                  //     // Swal.fire('Saved!', '', 'success')

                                  //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  //   } else if (result.isDenied) {
                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                  //   }
                                  // })

                                  // if(type == 1){
                                  //   var todayForm = new Date();
                                  //   var yearForm = todayForm.getFullYear();
                                  //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                  //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                  //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                  //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                  //   this.formTitle = 'title_'+todayForm;
                                  // } else {
                                  //   this.formTitle = response.data.return_data.name;
                                  // }

                                  // this.showModal = true
                                  // console.log('發佈 this.target');
                                  // console.log(this.target);
                                  if(this.target == 3){
                                    // console.log('按下一步的發佈');
                                    if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                      // let name = this.campaign_name;
                                      // let currency = this.currencyData.currency;
                                      // let addition = this.goalsData.form_addition;
                                      // let daily_budget = this.methodData.daily_budget;
                                      // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                      // // if(addition == '' || addition == 0){
                                      // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                      // // }

                                      // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                      // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                      // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                      // if(this.dateData.end_date != '0000-00-00'){
                                      //   two_week_budget = this.total_budget;
                                      //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                      // }

                                      // Swal.fire({
                                      //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                      //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_text_c'],
                                      //   icon: 'warning',
                                      //   showCancelButton: true,
                                      //   confirmButtonColor: '#3085d6',
                                      //   cancelButtonColor: '#d33',
                                      //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['yes_button'],
                                      //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['no_button'],
                                      // }).then((result) => {
                                      //   if (result.isConfirmed) {
                                      //     // console.log(this.$route.params.id);

                                      //     this.releaseType = true
                                      //     this.style = 'z-index:100;';
                                      //     this.releasePercent = 5;
                                      //     let status = 1;
                                      //     let num = 0;
                                      //     let member_hash = this.$route.params.id;
                                      //     let advertiser_id = this.advertiser_id
                                      //     var bar5 = new ldBar("#myItem5");
                                      //     bar5.set(this.releasePercent);

                                      //     axios
                                      //       .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                      //         s_code: member_hash,
                                      //         campaign_id: this.db_campaign_id,
                                      //       }))
                                      //       .then((caResponse) => {
                                      //         // console.log('caResponse:'+caResponse.data.return_data);
                                      //         if(caResponse.data.status == 'success'){
                                      //           //進行進度條
                                      //           // console.log('發佈莞成，開始跑進度條');
                                      //           setInterval( () => {
                                      //             num++;
                                      //             if(num < 1200){
                                      //               // console.log('num:'+num);
                                      //               // console.log(this.releaseType);

                                      //               if(this.releaseType == true){
                                      //                 axios
                                      //                   .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                      //                     s_code: member_hash,
                                      //                     advertiser_id: this.advertiser_id,
                                      //                     campaign_id: this.db_campaign_id,
                                      //                   }))
                                      //                   .then((csResponse) => {
                                      //                     // console.log('csResponse:'+csResponse.data.return_data);
                                      //                     //進行進度條
                                      //                     if(status == 1){
                                      //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                      //                         this.releaseType = false
                                      //                         this.style = 'z-index:-1;';
                                      //                         bar5.set(0);
                                      //                         status = 0;
                                      //                         // Swal.fire({
                                      //                         //   icon: 'error',
                                      //                         //   title: '正式發佈',
                                      //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                      //                         //   showDenyButton: false,
                                      //                         //   showCancelButton: false,
                                      //                         //   confirmButtonText: '確定',
                                      //                         //   timer: 5000
                                      //                         //   // denyButtonText: `Don't save`,
                                      //                         // }).then((result) => {
                                      //                         //   if (result.isConfirmed) {
                                      //                         //     // Swal.fire('Saved!', '', 'success')
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   } else if (result.isDenied) {
                                      //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   }

                                      //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   }
                                      //                         // })
                                      //                         Swal.fire({
                                      //                           icon: 'error',
                                      //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                      //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                      //                           showDenyButton: false,
                                      //                           showCancelButton: false,
                                      //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                      //                         }).then((result) => {

                                      //                         })
                                      //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                      //                         status = 0;

                                      //                         axios
                                      //                           .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                      //                           .then((csResponse) => {
                                      //                             this.releaseType = false

                                      //                             Swal.fire({
                                      //                               icon: 'success',
                                      //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                      //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                      //                               showDenyButton: false,
                                      //                               showCancelButton: false,
                                      //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                      //                               timer: 5000
                                      //                               // denyButtonText: `Don't save`,
                                      //                             }).then((result) => {
                                      //                               /* Read more about isConfirmed, isDenied below */
                                      //                               if (result.isConfirmed) {
                                      //                                 // Swal.fire('Saved!', '', 'success')
                                      //                                 this.allPageLoading = true
                                      //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                               } else if (result.isDenied) {
                                      //                                 // Swal.fire('Changes are not saved', '', 'info')
                                      //                                 this.allPageLoading = true
                                      //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                               }

                                      //                               if (result.dismiss === Swal.DismissReason.timer) {
                                      //                                 this.allPageLoading = true
                                      //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                               }
                                      //                             })
                                      //                           });
                                      //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                      //                         this.releaseType = false
                                      //                         this.style = 'z-index:-1;';
                                      //                         bar5.set(0);
                                      //                         status = 0;
                                      //                         // Swal.fire({
                                      //                         //   icon: 'error',
                                      //                         //   title: '正式發佈',
                                      //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                      //                         //   showDenyButton: false,
                                      //                         //   showCancelButton: false,
                                      //                         //   confirmButtonText: '確定',
                                      //                         //   timer: 5000
                                      //                         //   // denyButtonText: `Don't save`,
                                      //                         // }).then((result) => {
                                      //                         //   /* Read more about isConfirmed, isDenied below */
                                      //                         //   if (result.isConfirmed) {
                                      //                         //     // Swal.fire('Saved!', '', 'success')
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   } else if (result.isDenied) {
                                      //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   }

                                      //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                      //                         //     this.allPageLoading = true
                                      //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                         //   }
                                      //                         // })
                                      //                         Swal.fire({
                                      //                           icon: 'error',
                                      //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                      //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                      //                           showDenyButton: false,
                                      //                           showCancelButton: false,
                                      //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                      //                         }).then((result) => {

                                      //                         })
                                      //                       } else {
                                      //                         this.releaseText = csResponse.data.return_data.info_text
                                      //                         this.releasePercent = csResponse.data.return_data.info_pct

                                      //                         bar5.set(this.releasePercent);
                                      //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                      //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                      //                         // console.log('this.releaseText:'+this.releaseText);
                                      //                         // console.log('this.releasePercent:'+this.releasePercent);

                                      //                         if(csResponse.data.return_data.info_pct == 100){
                                      //                           this.releaseType = false
                                      //                           this.style = 'z-index:-1;';
                                      //                           bar5.set(0);
                                      //                           status = 0;
                                      //                         }
                                      //                       }
                                      //                     }
                                      //                   });
                                      //               }
                                      //             } else {
                                      //               Swal.fire({
                                      //                 icon: 'warning',
                                      //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_title'],
                                      //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_html'],
                                      //                 showDenyButton: false,
                                      //                 showCancelButton: false,
                                      //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['else']['confirm_button'],
                                      //                 timer: 1000
                                      //                 // denyButtonText: `Don't save`,
                                      //               }).then((result) => {
                                      //                 /* Read more about isConfirmed, isDenied below */
                                      //                 if (result.isConfirmed) {
                                      //                   // Swal.fire('Saved!', '', 'success')
                                      //                   this.allPageLoading = true
                                      //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                 } else if (result.isDenied) {
                                      //                   // Swal.fire('Changes are not saved', '', 'info')
                                      //                   this.allPageLoading = true
                                      //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                 }

                                      //                 if (result.dismiss === Swal.DismissReason.timer) {
                                      //                   this.allPageLoading = true
                                      //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                      //                 }
                                      //               })
                                      //             }
                                      //           }, 3000);
                                      //         }
                                      //       });
                                      //   }
                                      // })
                                      this.release();
                                    } else {
                                      Swal.fire(
                                        this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['success']['swal_title'],
                                        response.data.info,
                                        'error'
                                      )
                                    }
                                  }

                                  // console.log('333222發佈 this.target');
                                  // console.log(this.target);

                                  // if(this.menu[1].show == false){
                                  console.log('b #3 this.target');
                                  console.log(this.target);
                                    if(this.process < 66){
                                      this.process += 33
                                      // console.log('now target:'+this.target);
                                      if (this.target <= 3) {
                                        this.target += 1
                                        this.menu[this.target-1].open = true
                                        this.menu[this.target-1].click = 1
                                      }
                                      // if(this.target == 2){
                                      //   this.target += 1
                                      // }
                                    }
                                  console.log('a #3 this.target');
                                  console.log(this.target);
                                  // } else {
                                  //   if(this.process < 75){
                                  //     this.process += 25
                                  //     // console.log('now target:'+this.target);
                                  //     if (this.target <= 4) {
                                  //       this.target += 1
                                  //       this.menu[this.target-1].open = true
                                  //       this.menu[this.target-1].click = 1
                                  //     }
                                  //     // console.log('next target:'+this.target);
                                  //   }
                                  // }
                                  // console.log('next target:'+this.target);
                                  document.getElementById('edit_content').scrollTop = 0;
                                } else {
                                  let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['not_success']['default_swal_text'];
                                  if(response.data.info != '' && response.data.info != null){
                                    text = response.data.info
                                  }
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['campaign_update']['not_success']['swal_title'],
                                    text,
                                    'error'
                                  )
                                }
                              });
                          }
                        } else {
                          // console.log('#3');
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['not_creative_array_swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['target_3']['not_creative_array_swal_text'],
                                      "error"
                                    )
                        }
                      } else {
                        axios
                          .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: type,
                            target: 'add_next_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              // Swal.fire({
                              //   icon: 'success',
                              //   title: '儲存',
                              //   text: response.data.info,
                              //   showDenyButton: false,
                              //   showCancelButton: false,
                              //   confirmButtonText: '確定',
                              //   // denyButtonText: `Don't save`,
                              // }).then((result) => {
                              //   if (result.isConfirmed) {
                              //     // Swal.fire('Saved!', '', 'success')

                              //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              //   } else if (result.isDenied) {
                              //     // Swal.fire('Changes are not saved', '', 'info')
                              //   }
                              // })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                              // console.log('發佈 this.target');
                              // console.log(this.target);
                              if(this.target == 3){
                                // console.log('按下一步的發佈');
                                if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                  // let name = this.campaign_name;
                                  // let currency = this.currencyData.currency;
                                  // let addition = this.goalsData.form_addition;
                                  // let daily_budget = this.methodData.daily_budget;
                                  // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // if(addition == '' || addition == 0){
                                  // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                  // // }

                                  // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                  // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                  // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                  // if(this.dateData.end_date != '0000-00-00'){
                                  //   two_week_budget = this.total_budget;
                                  //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                  // }

                                  // Swal.fire({
                                  //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_c'],
                                  //   icon: 'warning',
                                  //   showCancelButton: true,
                                  //   confirmButtonColor: '#3085d6',
                                  //   cancelButtonColor: '#d33',
                                  //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['yes_button'],
                                  //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['no_button'],
                                  // }).then((result) => {
                                  //   if (result.isConfirmed) {
                                  //     // console.log(this.$route.params.id);

                                  //     this.releaseType = true
                                  //     this.style = 'z-index:100;';
                                  //     this.releasePercent = 5;
                                  //     let status = 1;
                                  //     let num = 0;
                                  //     let member_hash = this.$route.params.id;
                                  //     let advertiser_id = this.advertiser_id
                                  //     var bar5 = new ldBar("#myItem5");
                                  //     bar5.set(this.releasePercent);

                                  //     axios
                                  //       .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                  //         s_code: member_hash,
                                  //         campaign_id: this.db_campaign_id,
                                  //       }))
                                  //       .then((caResponse) => {
                                  //         // console.log('caResponse:'+caResponse.data.return_data);
                                  //         if(caResponse.data.status == 'success'){
                                  //           //進行進度條
                                  //           // console.log('發佈莞成，開始跑進度條');
                                  //           setInterval( () => {
                                  //             num++;
                                  //             if(num < 1200){
                                  //               // console.log('num:'+num);
                                  //               // console.log(this.releaseType);

                                  //               if(this.releaseType == true){
                                  //                 axios
                                  //                   .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                  //                     s_code: member_hash,
                                  //                     advertiser_id: this.advertiser_id,
                                  //                     campaign_id: this.db_campaign_id,
                                  //                   }))
                                  //                   .then((csResponse) => {
                                  //                     // console.log('csResponse:'+csResponse.data.return_data);
                                  //                     //進行進度條
                                  //                     if(status == 1){
                                  //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                  //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                  //                         status = 0;

                                  //                         axios
                                  //                           .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                  //                           .then((csResponse) => {
                                  //                             this.releaseType = false

                                  //                             Swal.fire({
                                  //                               icon: 'success',
                                  //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                  //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                  //                               showDenyButton: false,
                                  //                               showCancelButton: false,
                                  //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                  //                               timer: 5000
                                  //                               // denyButtonText: `Don't save`,
                                  //                             }).then((result) => {
                                  //                               /* Read more about isConfirmed, isDenied below */
                                  //                               if (result.isConfirmed) {
                                  //                                 // Swal.fire('Saved!', '', 'success')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                               } else if (result.isDenied) {
                                  //                                 // Swal.fire('Changes are not saved', '', 'info')
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                               }

                                  //                               if (result.dismiss === Swal.DismissReason.timer) {
                                  //                                 this.allPageLoading = true
                                  //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                               }
                                  //                             })
                                  //                           });
                                  //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                  //                         this.releaseType = false
                                  //                         this.style = 'z-index:-1;';
                                  //                         bar5.set(0);
                                  //                         status = 0;
                                  //                         // Swal.fire({
                                  //                         //   icon: 'error',
                                  //                         //   title: '正式發佈',
                                  //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                  //                         //   showDenyButton: false,
                                  //                         //   showCancelButton: false,
                                  //                         //   confirmButtonText: '確定',
                                  //                         //   timer: 5000
                                  //                         //   // denyButtonText: `Don't save`,
                                  //                         // }).then((result) => {
                                  //                         //   /* Read more about isConfirmed, isDenied below */
                                  //                         //   if (result.isConfirmed) {
                                  //                         //     // Swal.fire('Saved!', '', 'success')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   } else if (result.isDenied) {
                                  //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   }

                                  //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                  //                         //     this.allPageLoading = true
                                  //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                         //   }
                                  //                         // })
                                  //                         Swal.fire({
                                  //                           icon: 'error',
                                  //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                  //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                  //                           showDenyButton: false,
                                  //                           showCancelButton: false,
                                  //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                  //                         }).then((result) => {

                                  //                         })
                                  //                       } else {
                                  //                         this.releaseText = csResponse.data.return_data.info_text
                                  //                         this.releasePercent = csResponse.data.return_data.info_pct

                                  //                         bar5.set(this.releasePercent);
                                  //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                  //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                  //                         // console.log('this.releaseText:'+this.releaseText);
                                  //                         // console.log('this.releasePercent:'+this.releasePercent);

                                  //                         if(csResponse.data.return_data.info_pct == 100){
                                  //                           this.releaseType = false
                                  //                           this.style = 'z-index:-1;';
                                  //                           bar5.set(0);
                                  //                           status = 0;
                                  //                         }
                                  //                       }
                                  //                     }
                                  //                   });
                                  //               }
                                  //             } else {
                                  //               Swal.fire({
                                  //                 icon: 'warning',
                                  //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_title'],
                                  //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_html'],
                                  //                 showDenyButton: false,
                                  //                 showCancelButton: false,
                                  //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['else']['confirm_button'],
                                  //                 timer: 1000
                                  //                 // denyButtonText: `Don't save`,
                                  //               }).then((result) => {
                                  //                 /* Read more about isConfirmed, isDenied below */
                                  //                 if (result.isConfirmed) {
                                  //                   // Swal.fire('Saved!', '', 'success')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                 } else if (result.isDenied) {
                                  //                   // Swal.fire('Changes are not saved', '', 'info')
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                 }

                                  //                 if (result.dismiss === Swal.DismissReason.timer) {
                                  //                   this.allPageLoading = true
                                  //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                  //                 }
                                  //               })
                                  //             }
                                  //           }, 3000);
                                  //         }
                                  //       });
                                  //   }
                                  // })

                                  this.release();
                                } else {
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title'],
                                    response.data.info,
                                    'error'
                                  )
                                }
                              }

                              // console.log('333222發佈 this.target');
                              // console.log(this.target);

                              // if(this.menu[1].show == false){
                              console.log('b #4 this.target');
                              console.log(this.target);
                                if(this.process < 66){
                                  this.process += 33
                                  // console.log('now target:'+this.target);
                                  if (this.target <= 3) {
                                    this.target += 1
                                    this.menu[this.target-1].open = true
                                    this.menu[this.target-1].click = 1
                                  }
                                  // if(this.target == 2){
                                  //   this.target += 1
                                  // }
                                }
                              console.log('a #4 this.target');
                              console.log(this.target);
                              // } else {
                              //   if(this.process < 75){
                              //     this.process += 25
                              //     // console.log('now target:'+this.target);
                              //     if (this.target <= 4) {
                              //       this.target += 1
                              //       this.menu[this.target-1].open = true
                              //       this.menu[this.target-1].click = 1
                              //     }
                              //     // console.log('next target:'+this.target);
                              //   }
                              // }
                              // console.log('next target:'+this.target);
                              document.getElementById('edit_content').scrollTop = 0;
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['lead_messages']['not_target_3']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: type,
                          target: 'add_next_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            // Swal.fire({
                            //   icon: 'success',
                            //   title: '儲存',
                            //   text: response.data.info,
                            //   showDenyButton: false,
                            //   showCancelButton: false,
                            //   confirmButtonText: '確定',
                            //   // denyButtonText: `Don't save`,
                            // }).then((result) => {
                            //   if (result.isConfirmed) {
                            //     // Swal.fire('Saved!', '', 'success')

                            //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            //   } else if (result.isDenied) {
                            //     // Swal.fire('Changes are not saved', '', 'info')
                            //   }
                            // })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                            // console.log('發佈 this.target');
                            // console.log(this.target);
                            if(this.target == 3){
                              console.log('按下一步的發佈');
                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                // let name = this.campaign_name;
                                // let currency = this.currencyData.currency;
                                // let addition = this.goalsData.form_addition;
                                // let daily_budget = this.methodData.daily_budget;
                                // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // if(addition == '' || addition == 0){
                                // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // }

                                // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                // if(this.dateData.end_date != '0000-00-00'){
                                //   two_week_budget = this.total_budget;
                                //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                // }

                                // Swal.fire({
                                //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                                //   icon: 'warning',
                                //   showCancelButton: true,
                                //   confirmButtonColor: '#3085d6',
                                //   cancelButtonColor: '#d33',
                                //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['yes_button'],
                                //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['no_button'],
                                // }).then((result) => {
                                //   if (result.isConfirmed) {
                                //     // console.log(this.$route.params.id);

                                //     this.releaseType = true
                                //     this.style = 'z-index:100;';
                                //     this.releasePercent = 5;
                                //     let status = 1;
                                //     let num = 0;
                                //     let member_hash = this.$route.params.id;
                                //     let advertiser_id = this.advertiser_id
                                //     var bar5 = new ldBar("#myItem5");
                                //     bar5.set(this.releasePercent);

                                //     axios
                                //       .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                //         s_code: member_hash,
                                //         campaign_id: this.db_campaign_id,
                                //       }))
                                //       .then((caResponse) => {
                                //         // console.log('caResponse:'+caResponse.data.return_data);
                                //         if(caResponse.data.status == 'success'){
                                //           //進行進度條
                                //           // console.log('發佈莞成，開始跑進度條');
                                //           setInterval( () => {
                                //             num++;
                                //             if(num < 1200){
                                //               // console.log('num:'+num);
                                //               // console.log(this.releaseType);

                                //               if(this.releaseType == true){
                                //                 axios
                                //                   .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                //                     s_code: member_hash,
                                //                     advertiser_id: this.advertiser_id,
                                //                     campaign_id: this.db_campaign_id,
                                //                   }))
                                //                   .then((csResponse) => {
                                //                     // console.log('csResponse:'+csResponse.data.return_data);
                                //                     //進行進度條
                                //                     if(status == 1){
                                //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                //                         }).then((result) => {

                                //                         })
                                //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                //                         status = 0;

                                //                         axios
                                //                           .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                //                           .then((csResponse) => {
                                //                             this.releaseType = false

                                //                             Swal.fire({
                                //                               icon: 'success',
                                //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                //                               showDenyButton: false,
                                //                               showCancelButton: false,
                                //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                //                               timer: 5000
                                //                               // denyButtonText: `Don't save`,
                                //                             }).then((result) => {
                                //                               /* Read more about isConfirmed, isDenied below */
                                //                               if (result.isConfirmed) {
                                //                                 // Swal.fire('Saved!', '', 'success')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               } else if (result.isDenied) {
                                //                                 // Swal.fire('Changes are not saved', '', 'info')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               }

                                //                               if (result.dismiss === Swal.DismissReason.timer) {
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               }
                                //                             })
                                //                           });
                                //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   /* Read more about isConfirmed, isDenied below */
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                //                         }).then((result) => {

                                //                         })
                                //                       } else {
                                //                         this.releaseText = csResponse.data.return_data.info_text
                                //                         this.releasePercent = csResponse.data.return_data.info_pct

                                //                         bar5.set(this.releasePercent);
                                //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                //                         // console.log('this.releaseText:'+this.releaseText);
                                //                         // console.log('this.releasePercent:'+this.releasePercent);

                                //                         if(csResponse.data.return_data.info_pct == 100){
                                //                           this.releaseType = false
                                //                           this.style = 'z-index:-1;';
                                //                           bar5.set(0);
                                //                           status = 0;
                                //                         }
                                //                       }
                                //                     }
                                //                   });
                                //               }
                                //             } else {
                                //               Swal.fire({
                                //                 icon: 'warning',
                                //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                //                 showDenyButton: false,
                                //                 showCancelButton: false,
                                //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                //                 timer: 1000
                                //                 // denyButtonText: `Don't save`,
                                //               }).then((result) => {
                                //                 /* Read more about isConfirmed, isDenied below */
                                //                 if (result.isConfirmed) {
                                //                   // Swal.fire('Saved!', '', 'success')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 } else if (result.isDenied) {
                                //                   // Swal.fire('Changes are not saved', '', 'info')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 }

                                //                 if (result.dismiss === Swal.DismissReason.timer) {
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 }
                                //               })
                                //             }
                                //           }, 3000);
                                //         }
                                //       });
                                //   }
                                // })

                                this.release();
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }
                            }

                            // console.log('333222發佈 this.target');
                            // console.log(this.target);

                            // if(this.menu[1].show == false){
                            console.log('b #5 this.target');
                            console.log(this.target);
                              if(this.process < 66){
                                this.process += 33
                                // console.log('now target:'+this.target);
                                if (this.target <= 3) {
                                  this.target += 1
                                  this.menu[this.target-1].open = true
                                  this.menu[this.target-1].click = 1
                                }
                                // if(this.target == 2){
                                //   this.target += 1
                                // }
                              }
                            console.log('a #5 this.target');
                            console.log(this.target);
                            // } else {
                            //   if(this.process < 75){
                            //     this.process += 25
                            //     // console.log('now target:'+this.target);
                            //     if (this.target <= 4) {
                            //       this.target += 1
                            //       this.menu[this.target-1].open = true
                            //       this.menu[this.target-1].click = 1
                            //     }
                            //     // console.log('next target:'+this.target);
                            //   }
                            // }
                            // console.log('next target:'+this.target);
                            document.getElementById('edit_content').scrollTop = 0;
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['warning']['campaign_add_update']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  console.log(this.goalsData);
                  console.log(this.exAudiencesData);
                  console.log(_tmp_goalsData);
                  console.log(_tmp_exAudiencesData);
                  console.log(_view_goalsData);
                  console.log(_view_exAudiencesData);

                  console.log('======b');

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  console.log('======a');

                  console.log(this.goalsData);
                  console.log(this.exAudiencesData);
                  console.log(_tmp_goalsData);
                  console.log(_tmp_exAudiencesData);
                  console.log(_view_goalsData);
                  console.log(_view_exAudiencesData);

                  let formData = {
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  console.log('#2 campaign_add_update');

                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_add_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);

                      if(response.data.status == 'success'){
                        this.db_campaign_id = response.data.campaign_id
                        // axios
                        //   .post('https://test.autoturn.net/inside/api/tiktok/data/teaching_update.php', Qs.stringify({
                        //     s_code: this.$route.params.id,
                        //     id: this.teaching_id,
                        //     campaign_id: this.db_campaign_id,
                        //     campaign_objective: '',
                        //     skip: '',
                        //     step: '',
                        //     active: 'campaign_id'
                        //   }));

                        // console.log('333111發佈 this.target');
                        // console.log(this.target);

                        // if(this.menu[1].show == false){
                        console.log('b #6 this.target');
                        console.log(this.target);
                          if(this.process < 66){
                            this.process += 33
                            // console.log('now target:'+this.target);
                            if (this.target <= 3) {
                              this.target += 1
                              this.menu[this.target-1].open = true
                              this.menu[this.target-1].click = 1
                            }
                            // if(this.target == 2){
                            //   this.target += 1
                            // }
                          }
                        console.log('a #6 this.target');
                        console.log(this.target);
                        // } else {
                        //   if(this.process < 75){
                        //     this.process += 25
                        //     // console.log('now target:'+this.target);
                        //     if (this.target <= 4) {
                        //       this.target += 1
                        //       this.menu[this.target-1].open = true
                        //       this.menu[this.target-1].click = 1
                        //     }
                        //     // console.log('next target:'+this.target);
                        //   }
                        // }
                        // console.log('next target:'+this.target);
                        document.getElementById('edit_content').scrollTop = 0;
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['empty_campaign_id']['campaign_add_update']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['empty_campaign_id']['campaign_add_update']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                } else {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  let type = '';
                  if(this.target == 3){
                    type = 'finish';
                  }

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    if(this.target == 3){
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }

                      if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                      console.log('this.postData.select_article');
                      console.log(this.postData.select_article);
                      console.log('this.postData.select_creatives_message');
                      console.log(this.postData.select_creatives_message);
                      console.log('this.adMaterialDataNew.creative_array');
                      console.log(this.adMaterialDataNew.creative_array);
                      console.log('this.goalsData.campaign_objective');
                      console.log(this.goalsData.campaign_objective);
                      console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');
                      console.log('#2 materialType:'+materialType);

                      if(materialType == 0){
                        // console.log('#2');
                        let message_sr_i = 0;
                        let form_sr_i = 0;
                        let message = 0;
                        let single_object_spec = 0;
                        let single_title = 0;
                        let materials_item = 0;
                        let materials_object_spec = 0;
                        let materials_title = 0;
                        let ad_name = 0;

                        for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                          if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                            ad_name = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 2){
                            let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                            if(materials_length < 2){
                              materials_item = 1;
                            } else {
                              for(let j = 0; j < materials_length; j++){
                                if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                  materials_object_spec = 1;
                                }

                                if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                  materials_title = 1;
                                }
                              }
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 1){
                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                              single_object_spec = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                              single_title = 1;
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                            message = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                            form_sr_i = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                            message_sr_i = 1;
                          }
                        }

                        if(ad_name == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                                      "error"
                                    )
                        } else if(single_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(single_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                                      "error"
                                    )
                        } else if(materials_item == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                                      "error"
                                    )
                        } else if(materials_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(materials_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                                      "error"
                                    )
                        } else if(message == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                                      "error"
                                    )
                        } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                                    "error"
                                  )
                        } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                                    "error"
                                  )
                        } else {
                          // console.log('#5');
                          axios
                            .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: type,
                              target: 'add_next_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                // Swal.fire({
                                //   icon: 'success',
                                //   title: '儲存',
                                //   text: response.data.info,
                                //   showDenyButton: false,
                                //   showCancelButton: false,
                                //   confirmButtonText: '確定',
                                //   // denyButtonText: `Don't save`,
                                // }).then((result) => {
                                //   if (result.isConfirmed) {
                                //     // Swal.fire('Saved!', '', 'success')

                                //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                //   } else if (result.isDenied) {
                                //     // Swal.fire('Changes are not saved', '', 'info')
                                //   }
                                // })

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                                // console.log('發佈 this.target');
                                // console.log(this.target);
                                if(this.target == 3){
                                  // console.log('按下一步的發佈');
                                  if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              //       let name = this.campaign_name;
                              //       let currency = this.currencyData.currency;
                              //       let addition = this.goalsData.form_addition;
                              //       let daily_budget = this.methodData.daily_budget;
                              //       // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              //       // if(addition == '' || addition == 0){
                              //       //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              //       // }

                              //       let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              //       let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              //       let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                              //       if(this.dateData.end_date != '0000-00-00'){
                              //         two_week_budget = this.total_budget;
                              //         campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                              //       }

                              //       Swal.fire({
                              //         title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              //         html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_text_c'],
                              //         icon: 'warning',
                              //         showCancelButton: true,
                              //         confirmButtonColor: '#3085d6',
                              //         cancelButtonColor: '#d33',
                              //         confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['yes_button'],
                              //         cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['no_button'],
                              //       }).then((result) => {
                              //         if (result.isConfirmed) {
                              //           // console.log(this.$route.params.id);

                              //           this.releaseType = true
                              //           this.style = 'z-index:100;';
                              //           this.releasePercent = 5;
                              //           let status = 1;
                              //           let num = 0;
                              //           let member_hash = this.$route.params.id;
                              //           let advertiser_id = this.advertiser_id
                    										// var bar5 = new ldBar("#myItem5");
                    										// bar5.set(this.releasePercent);

                              //           axios
                              //             .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                              //               s_code: member_hash,
                              //               campaign_id: this.db_campaign_id,
                              //             }))
                              //             .then((caResponse) => {
                              //               // console.log('caResponse:'+caResponse.data.return_data);
                              //               if(caResponse.data.status == 'success'){
                              //                 //進行進度條
                              //                 // console.log('發佈莞成，開始跑進度條');
                              //                 setInterval( () => {
                              //                   num++;
                              //                   if(num < 1200){
                              //                     // console.log('num:'+num);
                              //                     // console.log(this.releaseType);

                              //                     if(this.releaseType == true){
                              //                       axios
                              //                         .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                              //                           s_code: member_hash,
                              //                           advertiser_id: this.advertiser_id,
                              //                           campaign_id: this.db_campaign_id,
                              //                         }))
                              //                         .then((csResponse) => {
                              //                           // console.log('csResponse:'+csResponse.data.return_data);
                              //                           //進行進度條
                              //                           if(status == 1){
                              //                             if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                              //                               this.releaseType = false
                              //                               this.style = 'z-index:-1;';
                              //                               bar5.set(0);
                              //                               status = 0;
                              //                               // Swal.fire({
                              //                               //   icon: 'error',
                              //                               //   title: '正式發佈',
                              //                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                              //                               //   showDenyButton: false,
                              //                               //   showCancelButton: false,
                              //                               //   confirmButtonText: '確定',
                              //                               //   timer: 5000
                              //                               //   // denyButtonText: `Don't save`,
                              //                               // }).then((result) => {
                              //                               //   if (result.isConfirmed) {
                              //                               //     // Swal.fire('Saved!', '', 'success')
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   } else if (result.isDenied) {
                              //                               //     // Swal.fire('Changes are not saved', '', 'info')
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   }

                              //                               //   if (result.dismiss === Swal.DismissReason.timer) {
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   }
                              //                               // })
                              //                               Swal.fire({
                              //                                 icon: 'error',
                              //                                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                              //                                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                              //                                 showDenyButton: false,
                              //                                 showCancelButton: false,
                              //                                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                              //                               }).then((result) => {

                              //                               })
                              //                             } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                              //                               status = 0;

                              //                               axios
                              //                                 .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                              //                                 .then((csResponse) => {
                              //                                   this.releaseType = false

                              //                                   Swal.fire({
                              //                                     icon: 'success',
                              //                                     title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                              //                                     text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                              //                                     showDenyButton: false,
                              //                                     showCancelButton: false,
                              //                                     confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                              //                                     timer: 5000
                              //                                     // denyButtonText: `Don't save`,
                              //                                   }).then((result) => {
                              //                                     /* Read more about isConfirmed, isDenied below */
                              //                                     if (result.isConfirmed) {
                              //                                       // Swal.fire('Saved!', '', 'success')
                              //                                       this.allPageLoading = true
                              //                                       window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                                     } else if (result.isDenied) {
                              //                                       // Swal.fire('Changes are not saved', '', 'info')
                              //                                       this.allPageLoading = true
                              //                                       window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                                     }

                              //                                     if (result.dismiss === Swal.DismissReason.timer) {
                              //                                       this.allPageLoading = true
                              //                                       window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                                     }
                              //                                   })
                              //                                 });
                              //                             } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                              //                               this.releaseType = false
                              //                               this.style = 'z-index:-1;';
                              //                               bar5.set(0);
                              //                               status = 0;
                              //                               // Swal.fire({
                              //                               //   icon: 'error',
                              //                               //   title: '正式發佈',
                              //                               //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                              //                               //   showDenyButton: false,
                              //                               //   showCancelButton: false,
                              //                               //   confirmButtonText: '確定',
                              //                               //   timer: 5000
                              //                               //   // denyButtonText: `Don't save`,
                              //                               // }).then((result) => {
                              //                               //   /* Read more about isConfirmed, isDenied below */
                              //                               //   if (result.isConfirmed) {
                              //                               //     // Swal.fire('Saved!', '', 'success')
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   } else if (result.isDenied) {
                              //                               //     // Swal.fire('Changes are not saved', '', 'info')
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   }

                              //                               //   if (result.dismiss === Swal.DismissReason.timer) {
                              //                               //     this.allPageLoading = true
                              //                               //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               //   }
                              //                               // })
                              //                               Swal.fire({
                              //                                 icon: 'error',
                              //                                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_title'],
                              //                                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                              //                                 showDenyButton: false,
                              //                                 showCancelButton: false,
                              //                                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['state_failure']['confirm_button']
                              //                               }).then((result) => {

                              //                               })
                              //                             } else {
                              //                               this.releaseText = csResponse.data.return_data.info_text
                              //                               this.releasePercent = csResponse.data.return_data.info_pct

                              //                               bar5.set(this.releasePercent);
                              //                               // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                              //                               // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                              //                               // console.log('this.releaseText:'+this.releaseText);
                              //                               // console.log('this.releasePercent:'+this.releasePercent);

                              //                               if(csResponse.data.return_data.info_pct == 100){
                              //                                 this.releaseType = false
                              //                                 this.style = 'z-index:-1;';
                              //                                 bar5.set(0);
                              //                                 status = 0;
                              //                               }
                              //                             }
                              //                           }
                              //                         });
                              //                     }
                              //                   } else {
                              //                     Swal.fire({
                              //                       icon: 'warning',
                              //                       title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_title'],
                              //                       text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['swal_html'],
                              //                       showDenyButton: false,
                              //                       showCancelButton: false,
                              //                       confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['else']['confirm_button'],
                              //                       timer: 1000
                              //                       // denyButtonText: `Don't save`,
                              //                     }).then((result) => {
                              //                       /* Read more about isConfirmed, isDenied below */
                              //                       if (result.isConfirmed) {
                              //                         // Swal.fire('Saved!', '', 'success')
                              //                         this.allPageLoading = true
                              //                         window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                       } else if (result.isDenied) {
                              //                         // Swal.fire('Changes are not saved', '', 'info')
                              //                         this.allPageLoading = true
                              //                         window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                       }

                              //                       if (result.dismiss === Swal.DismissReason.timer) {
                              //                         this.allPageLoading = true
                              //                         window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                       }
                              //                     })
                              //                   }
                              //                 }, 3000);
                              //               }
                              //             });
                              //         }
                              //       })
                                    this.release();
                                  } else {
                                    Swal.fire(
                                      this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['success']['swal_title'],
                                      response.data.info,
                                      'error'
                                    )
                                  }
                                }

                                // console.log('333222發佈 this.target');
                                // console.log(this.target);

                                // if(this.menu[1].show == false){
                                console.log('b #7 this.target');
                                console.log(this.target);
                                  if(this.process < 66){
                                    this.process += 33
                                    // console.log('now target:'+this.target);
                                    if (this.target <= 3) {
                                      this.target += 1
                                      this.menu[this.target-1].open = true
                                      this.menu[this.target-1].click = 1
                                    }
                                    // if(this.target == 2){
                                    //   this.target += 1
                                    // }
                                  }
                                console.log('a #7 this.target');
                                console.log(this.target);
                                // } else {
                                //   if(this.process < 75){
                                //     this.process += 25
                                //     // console.log('now target:'+this.target);
                                //     if (this.target <= 4) {
                                //       this.target += 1
                                //       this.menu[this.target-1].open = true
                                //       this.menu[this.target-1].click = 1
                                //     }
                                //     // console.log('next target:'+this.target);
                                //   }
                                // }
                                // console.log('next target:'+this.target);
                                document.getElementById('edit_content').scrollTop = 0;
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }
                            });
                        }
                      } else {
                        // console.log('#3');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['target_3']['not_creative_array_swal_text'],
                                    "error"
                                  )
                      }
                    } else {
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: type,
                          target: 'add_next_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            // Swal.fire({
                            //   icon: 'success',
                            //   title: '儲存',
                            //   text: response.data.info,
                            //   showDenyButton: false,
                            //   showCancelButton: false,
                            //   confirmButtonText: '確定',
                            //   // denyButtonText: `Don't save`,
                            // }).then((result) => {
                            //   if (result.isConfirmed) {
                            //     // Swal.fire('Saved!', '', 'success')

                            //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            //   } else if (result.isDenied) {
                            //     // Swal.fire('Changes are not saved', '', 'info')
                            //   }
                            // })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                            // console.log('發佈 this.target');
                            // console.log(this.target);
                            if(this.target == 3){
                              // console.log('按下一步的發佈');
                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                // let name = this.campaign_name;
                                // let currency = this.currencyData.currency;
                                // let addition = this.goalsData.form_addition;
                                // let daily_budget = this.methodData.daily_budget;
                                // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // if(addition == '' || addition == 0){
                                // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // // }

                                // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                // if(this.dateData.end_date != '0000-00-00'){
                                //   two_week_budget = this.total_budget;
                                //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                // }

                                // Swal.fire({
                                //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_text_c'],
                                //   icon: 'warning',
                                //   showCancelButton: true,
                                //   confirmButtonColor: '#3085d6',
                                //   cancelButtonColor: '#d33',
                                //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['yes_button'],
                                //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['no_button'],
                                // }).then((result) => {
                                //   if (result.isConfirmed) {
                                //     // console.log(this.$route.params.id);

                                //     this.releaseType = true
                                //     this.style = 'z-index:100;';
                                //     this.releasePercent = 5;
                                //     let status = 1;
                                //     let num = 0;
                                //     let member_hash = this.$route.params.id;
                                //     let advertiser_id = this.advertiser_id
                                //     var bar5 = new ldBar("#myItem5");
                                //     bar5.set(this.releasePercent);

                                //     axios
                                //       .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                //         s_code: member_hash,
                                //         campaign_id: this.db_campaign_id,
                                //       }))
                                //       .then((caResponse) => {
                                //         // console.log('caResponse:'+caResponse.data.return_data);
                                //         if(caResponse.data.status == 'success'){
                                //           //進行進度條
                                //           // console.log('發佈莞成，開始跑進度條');
                                //           setInterval( () => {
                                //             num++;
                                //             if(num < 1200){
                                //               // console.log('num:'+num);
                                //               // console.log(this.releaseType);

                                //               if(this.releaseType == true){
                                //                 axios
                                //                   .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                //                     s_code: member_hash,
                                //                     advertiser_id: this.advertiser_id,
                                //                     campaign_id: this.db_campaign_id,
                                //                   }))
                                //                   .then((csResponse) => {
                                //                     // console.log('csResponse:'+csResponse.data.return_data);
                                //                     //進行進度條
                                //                     if(status == 1){
                                //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_title'],
                                //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_failure']['confirm_button']
                                //                         }).then((result) => {

                                //                         })
                                //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                //                         status = 0;

                                //                         axios
                                //                           .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                //                           .then((csResponse) => {
                                //                             this.releaseType = false

                                //                             Swal.fire({
                                //                               icon: 'success',
                                //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_title'],
                                //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['swal_html'],
                                //                               showDenyButton: false,
                                //                               showCancelButton: false,
                                //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['info_state_success']['confirm_button'],
                                //                               timer: 5000
                                //                               // denyButtonText: `Don't save`,
                                //                             }).then((result) => {
                                //                               /* Read more about isConfirmed, isDenied below */
                                //                               if (result.isConfirmed) {
                                //                                 // Swal.fire('Saved!', '', 'success')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               } else if (result.isDenied) {
                                //                                 // Swal.fire('Changes are not saved', '', 'info')
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               }

                                //                               if (result.dismiss === Swal.DismissReason.timer) {
                                //                                 this.allPageLoading = true
                                //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                               }
                                //                             })
                                //                           });
                                //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                //                         this.releaseType = false
                                //                         this.style = 'z-index:-1;';
                                //                         bar5.set(0);
                                //                         status = 0;
                                //                         // Swal.fire({
                                //                         //   icon: 'error',
                                //                         //   title: '正式發佈',
                                //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                //                         //   showDenyButton: false,
                                //                         //   showCancelButton: false,
                                //                         //   confirmButtonText: '確定',
                                //                         //   timer: 5000
                                //                         //   // denyButtonText: `Don't save`,
                                //                         // }).then((result) => {
                                //                         //   /* Read more about isConfirmed, isDenied below */
                                //                         //   if (result.isConfirmed) {
                                //                         //     // Swal.fire('Saved!', '', 'success')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   } else if (result.isDenied) {
                                //                         //     // Swal.fire('Changes are not saved', '', 'info')
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }

                                //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                                //                         //     this.allPageLoading = true
                                //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                         //   }
                                //                         // })
                                //                         Swal.fire({
                                //                           icon: 'error',
                                //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_title'],
                                //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                //                           showDenyButton: false,
                                //                           showCancelButton: false,
                                //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['state_failure']['confirm_button']
                                //                         }).then((result) => {

                                //                         })
                                //                       } else {
                                //                         this.releaseText = csResponse.data.return_data.info_text
                                //                         this.releasePercent = csResponse.data.return_data.info_pct

                                //                         bar5.set(this.releasePercent);
                                //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                //                         // console.log('this.releaseText:'+this.releaseText);
                                //                         // console.log('this.releasePercent:'+this.releasePercent);

                                //                         if(csResponse.data.return_data.info_pct == 100){
                                //                           this.releaseType = false
                                //                           this.style = 'z-index:-1;';
                                //                           bar5.set(0);
                                //                           status = 0;
                                //                         }
                                //                       }
                                //                     }
                                //                   });
                                //               }
                                //             } else {
                                //               Swal.fire({
                                //                 icon: 'warning',
                                //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_title'],
                                //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['else']['swal_html'],
                                //                 showDenyButton: false,
                                //                 showCancelButton: false,
                                //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['else']['confirm_button'],
                                //                 timer: 1000
                                //                 // denyButtonText: `Don't save`,
                                //               }).then((result) => {
                                //                 /* Read more about isConfirmed, isDenied below */
                                //                 if (result.isConfirmed) {
                                //                   // Swal.fire('Saved!', '', 'success')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 } else if (result.isDenied) {
                                //                   // Swal.fire('Changes are not saved', '', 'info')
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 }

                                //                 if (result.dismiss === Swal.DismissReason.timer) {
                                //                   this.allPageLoading = true
                                //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                //                 }
                                //               })
                                //             }
                                //           }, 3000);
                                //         }
                                //       });
                                //   }
                                // })
                                this.release();
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }
                            }

                            // console.log('333222發佈 this.target');
                            // console.log(this.target);

                            // if(this.menu[1].show == false){
                            console.log('b #8 this.target');
                            console.log(this.target);
                              if(this.process < 66){
                                this.process += 33
                                // console.log('now target:'+this.target);
                                if (this.target <= 3) {
                                  this.target += 1
                                  this.menu[this.target-1].open = true
                                  this.menu[this.target-1].click = 1
                                }
                                // if(this.target == 2){
                                //   this.target += 1
                                // }
                              }
                            console.log('a #8 this.target');
                            console.log(this.target);
                            // } else {
                            //   if(this.process < 75){
                            //     this.process += 25
                            //     // console.log('now target:'+this.target);
                            //     if (this.target <= 4) {
                            //       this.target += 1
                            //       this.menu[this.target-1].open = true
                            //       this.menu[this.target-1].click = 1
                            //     }
                            //     // console.log('next target:'+this.target);
                            //   }
                            // }
                            // console.log('next target:'+this.target);
                            document.getElementById('edit_content').scrollTop = 0;
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_target_3']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  } else {
                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: type,
                        target: 'add_next_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          // Swal.fire({
                          //   icon: 'success',
                          //   title: '儲存',
                          //   text: response.data.info,
                          //   showDenyButton: false,
                          //   showCancelButton: false,
                          //   confirmButtonText: '確定',
                          //   // denyButtonText: `Don't save`,
                          // }).then((result) => {
                          //   if (result.isConfirmed) {
                          //     // Swal.fire('Saved!', '', 'success')

                          //     // window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          //   } else if (result.isDenied) {
                          //     // Swal.fire('Changes are not saved', '', 'info')
                          //   }
                          // })

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                          // console.log('發佈 this.target');
                          // console.log(this.target);
                          if(this.target == 3){
                            // console.log('按下一步的發佈');
                            if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              // let name = this.campaign_name;
                              // let currency = this.currencyData.currency;
                              // let addition = this.goalsData.form_addition;
                              // let daily_budget = this.methodData.daily_budget;
                              // // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // // if(addition == '' || addition == 0){
                              // //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // // }

                              // let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              // let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              // let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                              // if(this.dateData.end_date != '0000-00-00'){
                              //   two_week_budget = this.total_budget;
                              //   campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                              // }
                              // console.log('publish')
                              // Swal.fire({
                              //   title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              //   html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                              //   icon: 'warning',
                              //   showCancelButton: true,
                              //   confirmButtonColor: '#3085d6',
                              //   cancelButtonColor: '#d33',
                              //   confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['yes_button'],
                              //   cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['no_button'],
                              // }).then((result) => {
                              //   if (result.isConfirmed) {
                              //     // console.log(this.$route.params.id);

                              //     this.releaseType = true
                              //     this.style = 'z-index:100;';
                              //     this.releasePercent = 5;
                              //     let status = 1;
                              //     let num = 0;
                              //     let member_hash = this.$route.params.id;
                              //     let advertiser_id = this.advertiser_id
                              //     var bar5 = new ldBar("#myItem5");
                              //     bar5.set(this.releasePercent);

                              //     axios
                              //       .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                              //         s_code: member_hash,
                              //         campaign_id: this.db_campaign_id,
                              //       }))
                              //       .then((caResponse) => {
                              //         // console.log('caResponse:'+caResponse.data.return_data);
                              //         if(caResponse.data.status == 'success'){
                              //           //進行進度條
                              //           // console.log('發佈莞成，開始跑進度條');
                              //           setInterval( () => {
                              //             num++;
                              //             if(num < 1200){
                              //               // console.log('num:'+num);
                              //               // console.log(this.releaseType);

                              //               if(this.releaseType == true){
                              //                 axios
                              //                   .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                              //                     s_code: member_hash,
                              //                     advertiser_id: this.advertiser_id,
                              //                     campaign_id: this.db_campaign_id,
                              //                   }))
                              //                   .then((csResponse) => {
                              //                     // console.log('csResponse:'+csResponse.data.return_data);
                              //                     //進行進度條
                              //                     if(status == 1){
                              //                       if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                              //                         this.releaseType = false
                              //                         this.style = 'z-index:-1;';
                              //                         bar5.set(0);
                              //                         status = 0;
                              //                         // Swal.fire({
                              //                         //   icon: 'error',
                              //                         //   title: '正式發佈',
                              //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                              //                         //   showDenyButton: false,
                              //                         //   showCancelButton: false,
                              //                         //   confirmButtonText: '確定',
                              //                         //   timer: 5000
                              //                         //   // denyButtonText: `Don't save`,
                              //                         // }).then((result) => {
                              //                         //   if (result.isConfirmed) {
                              //                         //     // Swal.fire('Saved!', '', 'success')
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   } else if (result.isDenied) {
                              //                         //     // Swal.fire('Changes are not saved', '', 'info')
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   }

                              //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   }
                              //                         // })
                              //                         Swal.fire({
                              //                           icon: 'error',
                              //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                              //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                              //                           showDenyButton: false,
                              //                           showCancelButton: false,
                              //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                              //                         }).then((result) => {

                              //                         })
                              //                       } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                              //                         status = 0;

                              //                         axios
                              //                           .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                              //                           .then((csResponse) => {
                              //                             this.releaseType = false

                              //                             Swal.fire({
                              //                               icon: 'success',
                              //                               title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                              //                               text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                              //                               showDenyButton: false,
                              //                               showCancelButton: false,
                              //                               confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                              //                               timer: 5000
                              //                               // denyButtonText: `Don't save`,
                              //                             }).then((result) => {
                              //                               /* Read more about isConfirmed, isDenied below */
                              //                               if (result.isConfirmed) {
                              //                                 // Swal.fire('Saved!', '', 'success')
                              //                                 this.allPageLoading = true
                              //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               } else if (result.isDenied) {
                              //                                 // Swal.fire('Changes are not saved', '', 'info')
                              //                                 this.allPageLoading = true
                              //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               }

                              //                               if (result.dismiss === Swal.DismissReason.timer) {
                              //                                 this.allPageLoading = true
                              //                                 window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                               }
                              //                             })
                              //                           });
                              //                       } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                              //                         this.releaseType = false
                              //                         this.style = 'z-index:-1;';
                              //                         bar5.set(0);
                              //                         status = 0;
                              //                         // Swal.fire({
                              //                         //   icon: 'error',
                              //                         //   title: '正式發佈',
                              //                         //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                              //                         //   showDenyButton: false,
                              //                         //   showCancelButton: false,
                              //                         //   confirmButtonText: '確定',
                              //                         //   timer: 5000
                              //                         //   // denyButtonText: `Don't save`,
                              //                         // }).then((result) => {
                              //                         //   /* Read more about isConfirmed, isDenied below */
                              //                         //   if (result.isConfirmed) {
                              //                         //     // Swal.fire('Saved!', '', 'success')
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   } else if (result.isDenied) {
                              //                         //     // Swal.fire('Changes are not saved', '', 'info')
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   }

                              //                         //   if (result.dismiss === Swal.DismissReason.timer) {
                              //                         //     this.allPageLoading = true
                              //                         //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                         //   }
                              //                         // })
                              //                         Swal.fire({
                              //                           icon: 'error',
                              //                           title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                              //                           text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                              //                           showDenyButton: false,
                              //                           showCancelButton: false,
                              //                           confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                              //                         }).then((result) => {

                              //                         })
                              //                       } else {
                              //                         this.releaseText = csResponse.data.return_data.info_text
                              //                         this.releasePercent = csResponse.data.return_data.info_pct

                              //                         bar5.set(this.releasePercent);
                              //                         // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                              //                         // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                              //                         // console.log('this.releaseText:'+this.releaseText);
                              //                         // console.log('this.releasePercent:'+this.releasePercent);

                              //                         if(csResponse.data.return_data.info_pct == 100){
                              //                           this.releaseType = false
                              //                           this.style = 'z-index:-1;';
                              //                           bar5.set(0);
                              //                           status = 0;
                              //                         }
                              //                       }
                              //                     }
                              //                   });
                              //               }
                              //             } else {
                              //               Swal.fire({
                              //                 icon: 'warning',
                              //                 title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                              //                 text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                              //                 showDenyButton: false,
                              //                 showCancelButton: false,
                              //                 confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                              //                 timer: 1000
                              //                 // denyButtonText: `Don't save`,
                              //               }).then((result) => {
                              //                 /* Read more about isConfirmed, isDenied below */
                              //                 if (result.isConfirmed) {
                              //                   // Swal.fire('Saved!', '', 'success')
                              //                   this.allPageLoading = true
                              //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                 } else if (result.isDenied) {
                              //                   // Swal.fire('Changes are not saved', '', 'info')
                              //                   this.allPageLoading = true
                              //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                 }

                              //                 if (result.dismiss === Swal.DismissReason.timer) {
                              //                   this.allPageLoading = true
                              //                   window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                              //                 }
                              //               })
                              //             }
                              //           }, 3000);
                              //         }
                              //       });
                              //   }
                              // })
                              this.release();
                            } else {
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                response.data.info,
                                'error'
                              )
                            }
                          }

                          // console.log('333222發佈 this.target');
                          // console.log(this.target);

                          // if(this.menu[1].show == false){
                          console.log('b #9 this.target');
                          console.log(this.target);
                            if(this.process < 66){
                              this.process += 33
                              // console.log('now target:'+this.target);
                              if (this.target <= 3) {
                                this.target += 1
                                this.menu[this.target-1].open = true
                                this.menu[this.target-1].click = 1
                              }
                              // if(this.target == 2){
                              //   this.target += 1
                              // }
                            }
                          console.log('a #9 this.target');
                          console.log(this.target);
                          // } else {
                          //   if(this.process < 75){
                          //     this.process += 25
                          //     // console.log('now target:'+this.target);
                          //     if (this.target <= 4) {
                          //       this.target += 1
                          //       this.menu[this.target-1].open = true
                          //       this.menu[this.target-1].click = 1
                          //     }
                          //     // console.log('next target:'+this.target);
                          //   }
                          // }
                          // console.log('next target:'+this.target);
                          document.getElementById('edit_content').scrollTop = 0;
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['next']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        }
      },
      form_update(){
        // console.log('form_update');
        let isTrue = 1;

        this.changeYoutubeType();

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);

        // if(this.advertiser_id == null || this.advertiser_id == '' || typeof this.advertiser_id == 'undefined'){
        //   Swal.fire({
        //     icon: 'error',
        //     title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_adaccount_id_swal_title'],
        //     text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_adaccount_id_swal_text'],
        //     showDenyButton: false,
        //     showCancelButton: false,
        //     confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_adaccount_id_confirm_button']
        //     // denyButtonText: `Don't save`,
        //   }).then((result) => {
        //     /* Read more about isConfirmed, isDenied below */
        //     if (result.isConfirmed) {
        //       // Swal.fire('Saved!', '', 'success')
        //       this.allPageLoading = true
        //       window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
        //     } else if (result.isDenied) {
        //       // Swal.fire('Changes are not saved', '', 'info')
        //       this.allPageLoading = true
        //       window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id;
        //     }
        //   })

        //   isTrue = 0;
        // }

        // if(this.campaign_name == null || this.campaign_name == '' || typeof this.campaign_name == 'undefined'){
        //   Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_campaign_name_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_campaign_name_swal_text'],
        //                 "error"
        //               )
        //   let isTrue = 0;
        // }

        // if(this.target == 1){
        //   if(this.methodData.Target_KW == false && this.methodData.Target_DM == false && this.methodData.Target_LA == false && this.methodData.Target_RT == false){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_target_kw_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_target_kw_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if((this.methodData.Target_KW == true && this.methodData.Budget_KW == '') || (this.methodData.Target_DM == true && this.methodData.Budget_DM == '') || (this.methodData.Target_LA == true && this.methodData.Budget_LA == '') || (this.methodData.Target_RT == true && this.methodData.Budget_RT == '')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_budget_kw_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_budget_kw_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.methodData.Target_RT == true && (this.methodData.retargeting == '' || this.methodData.retargeting == [])){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_target_rt_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_target_rt_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }

        //   if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
        //     let startTime = this.dateData.start_date;
        //     let endTime = this.dateData.end_date;

        //     var sTime = new Date(startTime); //開始時間
        //     var eTime = new Date(endTime); //結束時間

        //     if(sTime > eTime){
        //       Swal.fire(
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_start_date_swal_title'],
        //                 this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_start_date_swal_text'],
        //                 "error"
        //               )
        //       isTrue = 0;
        //     }
        //   }

        //   // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

        //   if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_end_date_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_end_date_swal_text'],
        //               "error"
        //             )
        //     isTrue = 0;
        //   }
        // }

        // if(this.target == 3){
        //   if(this.pdData.auto_publisher == false && (this.pdData.publisher_platforms.length <= 0 || this.pdData.publisher_platforms == '' || this.pdData.publisher_platforms == null || typeof this.pdData.publisher_platforms == 'undefined')){
        //     Swal.fire(
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_auto_publisher_swal_title'],
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_auto_publisher_swal_text'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.idData.page_id == '' || this.idData.page_id == null || typeof this.idData.page_id == 'undefined'){
        //     Swal.fire(
        //               "Facebook",
        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_page_id_swal_text'],
        //               "error"
        //             )

        //     isTrue = 0;
        //   }

        //   if(this.goalsData.campaign_objective == 'CONVERSIONS' || this.goalsData.campaign_objective == 'LINK_CLICKS' || this.goalsData.campaign_objective == 'POST_ENGAGEMENT' || this.goalsData.campaign_objective == 'VIDEO_VIEWS'){
        //     if(this.postData.select_article.length <= 0){
        //       isTrue = 0;

        //       Swal.fire(
        //         this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_select_article_swal_title'],
        //         this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_select_article_swal_text'],
        //         'error'
        //       )
        //     }
        //   }

        //   if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
        //     let materialType = 0;
        //     let selectArticleLength = 0;
        //     if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
        //       selectArticleLength = this.postData.select_article.length;
        //     }

        //     let selectCreativesMessageLength = 0;
        //     if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
        //       selectCreativesMessageLength = this.postData.select_creatives_message.length;
        //     }

        //     let creativeArrayLength = 0;
        //     if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
        //       creativeArrayLength = this.adMaterialDataNew.creative_array.length;
        //     }

        //     if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
        //       materialType = 1;
        //     } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
        //       materialType = 2;
        //     }

        //     if(materialType != 0){
        //       isTrue = 0;

        //       Swal.fire(
        //         this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_creative_swal_title'],
        //         this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['empty_creative_swal_text'],
        //         'error'
        //       )
        //     }
        //   }
        // }

        // if(isTrue == 1){
          let member_hash = this.$route.params.id
          let advertiser_id = this.$route.params.adaccount_id

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'add',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_add_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                      }))
                      .then((response) => {
                        // console.log(response.data);

                        if(response.data.status == 'success'){
                          this.db_campaign_id = response.data.campaign_id
                          // axios
                          //   .post('https://test.autoturn.net/inside/api/tiktok/data/teaching_update.php', Qs.stringify({
                          //     s_code: this.$route.params.id,
                          //     id: this.teaching_id,
                          //     campaign_id: this.db_campaign_id,
                          //     campaign_objective: '',
                          //     skip: '',
                          //     step: '',
                          //     active: 'campaign_id'
                          //   }));

                          ////////////////
                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            }
                          })
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['empty_campaign_id']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  } else {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.db_campaign_id,
                      campaign_name: this.campaign_name,
                      advertiser_id: this.advertiser_id,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      methodData: this.methodData,
                      dateData: this.dateData,
                      keywordData: this.keywordData,
                      lookData: this.lookData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    // console.log('a this.adMaterialDataNew');
                    // console.log(this.adMaterialDataNew);

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }                 

                      if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                      if(materialType == 0){
                        // console.log('#2');
                        // let message_sr_i = 0;
                        // let form_sr_i = 0;
                        // let message = 0;
                        // let single_object_spec = 0;
                        // let single_title = 0;
                        // let materials_item = 0;
                        // let materials_object_spec = 0;
                        // let materials_title = 0;
                        // let ad_name = 0;

                        // for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                        //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                        //     ad_name = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                        //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                        //     if(materials_length < 2){
                        //       materials_item = 1;
                        //     } else {
                        //       for(let j = 0; j < materials_length; j++){
                        //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                        //           materials_object_spec = 1;
                        //         }

                        //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                        //           materials_title = 1;
                        //         }
                        //       }
                        //     }
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                        //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                        //       single_object_spec = 1;
                        //     }

                        //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                        //       single_title = 1;
                        //     }
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                        //     message = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                        //     form_sr_i = 1;
                        //   }

                        //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                        //     message_sr_i = 1;
                        //   }
                        // }

                        // if(ad_name == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                        //               "error"
                        //             )
                        // } else if(single_object_spec == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                        //               "error"
                        //             )
                        // } else if(single_title == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                        //               "error"
                        //             )
                        // } else if(materials_item == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                        //               "error"
                        //             )
                        // } else if(materials_object_spec == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                        //               "error"
                        //             )
                        // } else if(materials_title == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                        //               "error"
                        //             )
                        // } else if(message == 1){
                        //   Swal.fire(
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                        //               "error"
                        //             )
                        // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        //   Swal.fire(
                        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                        //             "error"
                        //           )
                        // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        //   Swal.fire(
                        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['swal_title'],
                        //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                        //             "error"
                        //           )
                        // } else {
                          // console.log('#5');
                          axios
                            .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: 'finish',
                              target: 'add_update_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                Swal.fire({
                                  icon: 'success',
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                  text: response.data.info,
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')

                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                  }
                                })

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                              } else {
                                let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                  text,
                                  'error'
                                )
                              }
                            });
                        // }
                      } else {
                        // console.log('#3');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                    "error"
                                  )
                      }
                    } else {
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'finish',
                          target: 'add_update_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              }
                            })

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['warning']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_add_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                    }))
                    .then((response) => {
                      // console.log(response.data);

                      if(response.data.status == 'success'){
                        this.db_campaign_id = response.data.campaign_id
                        // axios
                        //   .post('https://test.autoturn.net/inside/api/tiktok/data/teaching_update.php', Qs.stringify({
                        //     s_code: this.$route.params.id,
                        //     id: this.teaching_id,
                        //     campaign_id: this.db_campaign_id,
                        //     campaign_objective: '',
                        //     skip: '',
                        //     step: '',
                        //     active: 'campaign_id'
                        //   }));

                        Swal.fire({
                          icon: 'success',
                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['swal_title'],
                          text: response.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')

                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                          }
                        })
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['empty_campaign_id']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                } else {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  // console.log('b this.adMaterialDataNew');
                  // console.log(this.adMaterialDataNew);

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }                 

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    if(materialType == 0){
                      // console.log('#2');
                      // let message_sr_i = 0;
                      // let form_sr_i = 0;
                      // let message = 0;
                      // let single_object_spec = 0;
                      // let single_title = 0;
                      // let materials_item = 0;
                      // let materials_object_spec = 0;
                      // let materials_title = 0;
                      // let ad_name = 0;

                      // for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                      //   if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                      //     ad_name = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].type == 2){
                      //     let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                      //     if(materials_length < 2){
                      //       materials_item = 1;
                      //     } else {
                      //       for(let j = 0; j < materials_length; j++){
                      //         if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                      //           materials_object_spec = 1;
                      //         }

                      //         if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                      //           materials_title = 1;
                      //         }
                      //       }
                      //     }
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].type == 1){
                      //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                      //       single_object_spec = 1;
                      //     }

                      //     if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                      //       single_title = 1;
                      //     }
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                      //     message = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                      //     form_sr_i = 1;
                      //   }

                      //   if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                      //     message_sr_i = 1;
                      //   }
                      // }

                      // if(ad_name == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_ad_name_swal_text'],
                      //               "error"
                      //             )
                      // } else if(single_object_spec == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_object_spec_swal_text'],
                      //               "error"
                      //             )
                      // } else if(single_title == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_single_title_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_item == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_item_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_object_spec == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_object_spec_swal_text'],
                      //               "error"
                      //             )
                      // } else if(materials_title == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_materials_title_swal_text'],
                      //               "error"
                      //             )
                      // } else if(message == 1){
                      //   Swal.fire(
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //               this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_swal_text'],
                      //               "error"
                      //             )
                      // } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      //   Swal.fire(
                      //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_form_sr_i_swal_text'],
                      //             "error"
                      //           )
                      // } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                      //   Swal.fire(
                      //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['swal_title'],
                      //             this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_message_sr_i_swal_text'],
                      //             "error"
                      //           )
                      // } else {
                        // console.log('#5');
                        axios
                          .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'finish',
                            target: 'add_update_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['success']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      // }
                    } else {
                      // console.log('#3');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'finish',
                        target: 'add_update_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          Swal.fire({
                            icon: 'success',
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['swal_title'],
                            text: response.data.info,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['success']['confirm_button'],
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')

                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                            }
                          })

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['success']['have_campaign_id']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['form_update']['campaign_member_status']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });

        // }
      },
      release(){
        console.log('release');
        this.changeYoutubeType();

        if(this.db_campaign_id == null || this.db_campaign_id == '' || typeof this.db_campaign_id == 'undefined'){
          Swal.fire(
            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['empty_campaign_id']['swal_title'],
            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['empty_campaign_id']['swal_text'],
            'error'
          )
        } else {
          let member_hash = this.$route.params.id
          let advertiser_id = this.$route.params.adaccount_id

          axios
            .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
              s_code: member_hash,
              route_type: this.$route.params.type,
              active: 'release',
            }))
            .then((caResponse) => {

              if(caResponse.data.status == 'error'){
                if(caResponse.data.type == 2){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                    }
                  })
                } else if(caResponse.data.type == 3){
                  Swal.fire({
                    icon: caResponse.data.status,
                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      this.allPageLoading = true
                      window.location.href = "https://dev-private.autoturn.net/t/"+member_hash;
                    }
                  })
                } else {
                  Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['error']['swal_title'],
                            caResponse.data.info,
                            caResponse.data.status
                          )
                }
              }

              if(caResponse.data.status == 'warning'){
                Swal.fire({
                  icon: 'warning',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.db_campaign_id,
                    campaign_name: this.campaign_name,
                    advertiser_id: this.advertiser_id,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    methodData: this.methodData,
                    dateData: this.dateData,
                    keywordData: this.keywordData,
                    lookData: this.lookData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  let advertiser_id = this.advertiser_id

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }                 

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    console.log('#3 materialType:'+materialType);

                    if(materialType == 0){
                      // console.log('#2');
                      let message_sr_i = 0;
                      let form_sr_i = 0;
                      let message = 0;
                      let single_object_spec = 0;
                      let single_title = 0;
                      let materials_item = 0;
                      let materials_object_spec = 0;
                      let materials_title = 0;
                      let ad_name = 0;

                      for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                        if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          ad_name = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 2){
                          let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          if(materials_length < 2){
                            materials_item = 1;
                          } else {
                            for(let j = 0; j < materials_length; j++){
                              if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                materials_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                materials_title = 1;
                              }
                            }
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 1){
                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                            single_object_spec = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                            single_title = 1;
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          message = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          form_sr_i = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          message_sr_i = 1;
                        }
                      }

                      if(ad_name == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_ad_name_swal_text'],
                                    "error"
                                  )
                      } else if(single_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_single_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(single_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_single_title_swal_text'],
                                    "error"
                                  )
                      } else if(materials_item == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_item_swal_text'],
                                    "error"
                                  )
                      } else if(materials_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(materials_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_materials_title_swal_text'],
                                    "error"
                                  )
                      } else if(message == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_message_swal_text'],
                                    "error"
                                  )
                      } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_form_sr_i_swal_text'],
                                  "error"
                                )
                      } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_message_sr_i_swal_text'],
                                  "error"
                                )
                      } else {
                        // console.log('#5');
                        axios
                          .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'release',
                            target: 'add_release_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                let name = this.campaign_name;
                                let currency = this.currencyData.currency;
                                let addition = this.goalsData.budget_increase;
                                let daily_budget = this.methodData.Budget_KW;
                                // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // if(addition == '' || addition == 0){
                                //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                                // }

                                let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                if(this.methodData.Target_AD == true){
                                  addition_text = '';
                                }
                                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                                if(this.dateData.end_date != '0000-00-00'){
                                  two_week_budget = this.total_budget;
                                  campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                                }

                                Swal.fire({
                                  // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                  html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#d33',
                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
                                  cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['no_button'],
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    // console.log(this.$route.params.id);

                                    this.releaseType = true
                                    this.style = 'z-index:100;';
                                    this.releasePercent = 5;
                                    let status = 1;
                                    let num = 0;
                                    let member_hash = this.$route.params.id;
                                    var bar5 = new ldBar("#myItem5");
                                    bar5.set(this.releasePercent);

                                    axios
                                      .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                        s_code: member_hash,
                                        campaign_id: this.db_campaign_id,
                                      }))
                                      .then((caResponse) => {
                                        // console.log('caResponse:'+caResponse.data.return_data);
                                        if(caResponse.data.status == 'success'){
                                          //進行進度條
                                          // console.log('發佈莞成，開始跑進度條');
                                          setInterval( () => {
                                            num++;
                                            if(num < 1200){
                                              // console.log('num:'+num);
                                              // console.log(this.releaseType);

                                              if(this.releaseType == true){
                                                axios
                                                  .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                    s_code: member_hash,
                                                    adaccount_id: this.advertiser_id,
                                                    campaign_id: this.db_campaign_id,
                                                  }))
                                                  .then((csResponse) => {
                                                    // console.log('csResponse:'+csResponse.data.return_data);
                                                    //進行進度條
                                                    if(status == 1){
                                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                        }).then((result) => {

                                                        })
                                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                        status = 0;

                                                        axios
                                                          .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                            s_code: member_hash,
                                                            id: this.db_campaign_id,
                                                          }))
                                                          .then((response) => {
                                                            axios
                                                              .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                              .then((csResponse) => {
                                                                this.releaseType = false

                                                                Swal.fire({
                                                                  icon: 'success',
                                                                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                  showDenyButton: false,
                                                                  showCancelButton: false,
                                                                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                  timer: 5000
                                                                  // denyButtonText: `Don't save`,
                                                                }).then((result) => {
                                                                  /* Read more about isConfirmed, isDenied below */
                                                                  if (result.isConfirmed) {
                                                                    // Swal.fire('Saved!', '', 'success')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                  } else if (result.isDenied) {
                                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                  }

                                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                  }
                                                                })
                                                              });
                                                          });
                                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        // Swal.fire({
                                                        //   icon: 'error',
                                                        //   title: '正式發佈',
                                                        //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                        //   showDenyButton: false,
                                                        //   showCancelButton: false,
                                                        //   confirmButtonText: '確定',
                                                        //   timer: 5000
                                                        //   // denyButtonText: `Don't save`,
                                                        // }).then((result) => {
                                                        //   /* Read more about isConfirmed, isDenied below */
                                                        //   if (result.isConfirmed) {
                                                        //     // Swal.fire('Saved!', '', 'success')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   } else if (result.isDenied) {
                                                        //     // Swal.fire('Changes are not saved', '', 'info')
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   }

                                                        //   if (result.dismiss === Swal.DismissReason.timer) {
                                                        //     this.allPageLoading = true
                                                        //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                        //   }
                                                        // })
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                        }).then((result) => {

                                                        })
                                                      } else {
                                                        this.releaseText = csResponse.data.return_data.info_text
                                                        this.releasePercent = csResponse.data.return_data.info_pct

                                                        bar5.set(this.releasePercent);
                                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                        // console.log('this.releaseText:'+this.releaseText);
                                                        // console.log('this.releasePercent:'+this.releasePercent);

                                                        if(csResponse.data.return_data.info_pct == 100){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                        }
                                                      }
                                                    }
                                                  });
                                              }
                                            } else {
                                              Swal.fire({
                                                icon: 'warning',
                                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                timer: 1000
                                                // denyButtonText: `Don't save`,
                                              }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                  // Swal.fire('Saved!', '', 'success')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                } else if (result.isDenied) {
                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                }

                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                }
                                              })
                                            }
                                          }, 3000);
                                        }
                                      });
                                  }
                                })
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      // console.log('#3');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    axios
                      .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'release',
                        target: 'add_release_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                            let name = this.campaign_name;
                            let currency = this.currencyData.currency;
                            let addition = this.goalsData.budget_increase;
                            let daily_budget = this.methodData.Budget_KW;
                            // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // if(addition == '' || addition == 0){
                            //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                            // }

                            let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                            if(this.methodData.Target_AD == true){
                              addition_text = '';
                            }
                            let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                            let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                            if(this.dateData.end_date != '0000-00-00'){
                              two_week_budget = this.total_budget;
                              campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                            }

                            Swal.fire({
                              // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
                              cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
                            }).then((result) => {
                              if (result.isConfirmed) {
                                // console.log(this.$route.params.id);

                                this.releaseType = true
                                this.style = 'z-index:100;';
                                this.releasePercent = 5;
                                let status = 1;
                                let num = 0;
                                let member_hash = this.$route.params.id;
                                var bar5 = new ldBar("#myItem5");
                                bar5.set(this.releasePercent);

                                axios
                                  .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                    s_code: member_hash,
                                    campaign_id: this.db_campaign_id,
                                  }))
                                  .then((caResponse) => {
                                    // console.log('caResponse:'+caResponse.data.return_data);
                                    if(caResponse.data.status == 'success'){
                                      //進行進度條
                                      // console.log('發佈莞成，開始跑進度條');
                                      setInterval( () => {
                                        num++;
                                        if(num < 1200){
                                          // console.log('num:'+num);
                                          // console.log(this.releaseType);

                                          if(this.releaseType == true){
                                            axios
                                              .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                s_code: member_hash,
                                                adaccount_id: this.advertiser_id,
                                                campaign_id: this.db_campaign_id,
                                              }))
                                              .then((csResponse) => {
                                                // console.log('csResponse:'+csResponse.data.return_data);
                                                //進行進度條
                                                if(status == 1){
                                                  if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                    }).then((result) => {

                                                    })
                                                  } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                    status = 0;

                                                    axios
                                                      .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                        s_code: member_hash,
                                                        id: this.db_campaign_id,
                                                      }))
                                                      .then((response) => {
                                                        axios
                                                          .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                          .then((csResponse) => {
                                                            this.releaseType = false

                                                            Swal.fire({
                                                              icon: 'success',
                                                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                              text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                              showDenyButton: false,
                                                              showCancelButton: false,
                                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                              timer: 5000
                                                              // denyButtonText: `Don't save`,
                                                            }).then((result) => {
                                                              /* Read more about isConfirmed, isDenied below */
                                                              if (result.isConfirmed) {
                                                                // Swal.fire('Saved!', '', 'success')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                              } else if (result.isDenied) {
                                                                // Swal.fire('Changes are not saved', '', 'info')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                              }

                                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                              }
                                                            })
                                                          });
                                                      });
                                                  } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    // Swal.fire({
                                                    //   icon: 'error',
                                                    //   title: '正式發佈',
                                                    //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                    //   showDenyButton: false,
                                                    //   showCancelButton: false,
                                                    //   confirmButtonText: '確定',
                                                    //   timer: 5000
                                                    //   // denyButtonText: `Don't save`,
                                                    // }).then((result) => {
                                                    //   /* Read more about isConfirmed, isDenied below */
                                                    //   if (result.isConfirmed) {
                                                    //     // Swal.fire('Saved!', '', 'success')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   } else if (result.isDenied) {
                                                    //     // Swal.fire('Changes are not saved', '', 'info')
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   }

                                                    //   if (result.dismiss === Swal.DismissReason.timer) {
                                                    //     this.allPageLoading = true
                                                    //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                    //   }
                                                    // })
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                    }).then((result) => {

                                                    })
                                                  } else {
                                                    this.releaseText = csResponse.data.return_data.info_text
                                                    this.releasePercent = csResponse.data.return_data.info_pct

                                                    bar5.set(this.releasePercent);
                                                    // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                    // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                    // console.log('this.releaseText:'+this.releaseText);
                                                    // console.log('this.releasePercent:'+this.releasePercent);

                                                    if(csResponse.data.return_data.info_pct == 100){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                    }
                                                  }
                                                }
                                              });
                                          }
                                        } else {
                                          Swal.fire({
                                            icon: 'warning',
                                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                            timer: 1000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                            }
                                          })
                                        }
                                      }, 3000);
                                    }
                                  });
                              }
                            })
                          } else {
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              response.data.info,
                              'error'
                            )
                          }

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                });
              }

              if(caResponse.data.status == 'success'){
                var daily_keyword_split_budget = this.methodData.Budget_KW;
                var daily_demo_budget = this.methodData.Budget_DM;
                var budget_addition = this.goalsData.form_addition;

                if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                    var d1 = new Date(this.dateData.start_date);
                    var d2 = new Date(this.dateData.end_date);
                    var days = parseInt((d2-d1)/86400000) + parseInt(1);
                } else {
                    var days = 0;
                }

                var keyword_split_budget = 0;
                if(this.methodData.Budget_KW != ''){
                    keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                }

                var demo_budget = 0;
                if(this.methodData.Budget_DM != ''){
                    demo_budget = this.methodData.Budget_DM * days;
                }

                var _tmp_audience_budget = 0;
                var audience_budget = 0;
                // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                var _tmp_marketing_again_budget = 0;
                var marketing_again_budget = 0;
                // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                if(isNaN(html)){
                    html = '0';
                }

                this.total_budget = html;

                let _tmp_goalsData = this.goalsData;
                const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                let _tmp_exAudiencesData = this.exAudiencesData;
                const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                // console.log(_tmp_exAudiencesData);

                delete _view_goalsData['objective_list'];
                delete _view_exAudiencesData['custom_excluded_audiences'];

                let formData = {
                  campaign_id: this.db_campaign_id,
                  campaign_name: this.campaign_name,
                  advertiser_id: this.advertiser_id,
                  Budget_KW_result: this.Budget_KW_result,
                  total_budget: this.total_budget,
                  methodData: this.methodData,
                  dateData: this.dateData,
                  keywordData: this.keywordData,
                  lookData: this.lookData,
                  goalsData: _view_goalsData,
                  regionsData: this.regionsData,
                  selectCountries: this.selectCountries,
                  selectLangs: this.selectLangs,
                  exAudiencesData: _view_exAudiencesData,
                  pdData: this.pdData,
                  idData: this.idData,
                  postData: this.postData,
                  adMaterialData: this.adMaterialDataNew
                }

                let advertiser_id = this.advertiser_id

                if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                  // console.log('#1');
                  let materialType = 0;
                  let selectArticleLength = 0;
                  if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                    selectArticleLength = this.postData.select_article.length;
                  }

                  let selectCreativesMessageLength = 0;
                  if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                    selectCreativesMessageLength = this.postData.select_creatives_message.length;
                  }

                  let creativeArrayLength = 0;
                  if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                    creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                  }                 

                  if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                    materialType = 1;
                  } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                    materialType = 2;
                  }

                  console.log('#4 materialType:'+materialType);

                  if(materialType == 0){
                    // console.log('#2');
                    let message_sr_i = 0;
                    let form_sr_i = 0;
                    let message = 0;
                    let single_object_spec = 0;
                    let single_title = 0;
                    let materials_item = 0;
                    let materials_object_spec = 0;
                    let materials_title = 0;
                    let ad_name = 0;

                    for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                      if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                        ad_name = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].type == 2){
                        let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                        if(materials_length < 2){
                          materials_item = 1;
                        } else {
                          for(let j = 0; j < materials_length; j++){
                            if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                              materials_object_spec = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                              materials_title = 1;
                            }
                          }
                        }
                      }

                      if(this.adMaterialDataNew.creative_array[i].type == 1){
                        if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                          single_object_spec = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                          single_title = 1;
                        }
                      }

                      if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                        message = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                        form_sr_i = 1;
                      }

                      if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                        message_sr_i = 1;
                      }
                    }

                    if(ad_name == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_ad_name_swal_text'],
                                  "error"
                                )
                    } else if(single_object_spec == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_single_object_spec_swal_text'],
                                  "error"
                                )
                    } else if(single_title == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_single_title_swal_text'],
                                  "error"
                                )
                    } else if(materials_item == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_item_swal_text'],
                                  "error"
                                )
                    } else if(materials_object_spec == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_object_spec_swal_text'],
                                  "error"
                                )
                    } else if(materials_title == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_materials_title_swal_text'],
                                  "error"
                                )
                    } else if(message == 1){
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_message_swal_text'],
                                  "error"
                                )
                    } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_form_sr_i_swal_text'],
                                "error"
                              )
                    } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                      Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['swal_title'],
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_message_sr_i_swal_text'],
                                "error"
                              )
                    } else {
                      // console.log('#5');
                      axios
                        .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'release',
                          target: 'add_release_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              let name = this.campaign_name;
                              let currency = this.currencyData.currency;
                              let addition = this.goalsData.budget_increase;
                              let daily_budget = this.methodData.Budget_KW;
                              // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // if(addition == '' || addition == 0){
                              //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                              // }

                              let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              if(this.methodData.Target_AD == true){
                                addition_text = '';
                              }
                              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                              if(this.dateData.end_date != '0000-00-00'){
                                two_week_budget = this.total_budget;
                                campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                              }

                              Swal.fire({
                                // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_title'],
                                html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                                cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['no_button'],
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(this.$route.params.id);

                                  this.releaseType = true
                                  this.style = 'z-index:100;';
                                  this.releasePercent = 5;
                                  let status = 1;
                                  let num = 0;
                                  let member_hash = this.$route.params.id;
                                  var bar5 = new ldBar("#myItem5");
                                  bar5.set(this.releasePercent);

                                  axios
                                    .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                      s_code: member_hash,
                                      campaign_id: this.db_campaign_id,
                                    }))
                                    .then((caResponse) => {
                                      // console.log('caResponse:'+caResponse.data.return_data);
                                      if(caResponse.data.status == 'success'){
                                        //進行進度條
                                        // console.log('發佈莞成，開始跑進度條');
                                        setInterval( () => {
                                          num++;
                                          if(num < 1200){
                                            // console.log('num:'+num);
                                            // console.log(this.releaseType);

                                            if(this.releaseType == true){
                                              axios
                                                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  adaccount_id: this.advertiser_id,
                                                  campaign_id: this.db_campaign_id,
                                                }))
                                                .then((csResponse) => {
                                                  // console.log('csResponse:'+csResponse.data.return_data);
                                                  //進行進度條
                                                  if(status == 1){
                                                    if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                      status = 0;

                                                      axios
                                                        .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                          s_code: member_hash,
                                                          id: this.db_campaign_id,
                                                        }))
                                                        .then((response) => {
                                                          axios
                                                            .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                            .then((csResponse) => {
                                                              this.releaseType = false

                                                              Swal.fire({
                                                                icon: 'success',
                                                                title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                showDenyButton: false,
                                                                showCancelButton: false,
                                                                confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                timer: 5000
                                                                // denyButtonText: `Don't save`,
                                                              }).then((result) => {
                                                                /* Read more about isConfirmed, isDenied below */
                                                                if (result.isConfirmed) {
                                                                  // Swal.fire('Saved!', '', 'success')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                } else if (result.isDenied) {
                                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                }

                                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                                }
                                                              })
                                                            });
                                                        });
                                                    } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      // Swal.fire({
                                                      //   icon: 'error',
                                                      //   title: '正式發佈',
                                                      //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                      //   showDenyButton: false,
                                                      //   showCancelButton: false,
                                                      //   confirmButtonText: '確定',
                                                      //   timer: 5000
                                                      //   // denyButtonText: `Don't save`,
                                                      // }).then((result) => {
                                                      //   /* Read more about isConfirmed, isDenied below */
                                                      //   if (result.isConfirmed) {
                                                      //     // Swal.fire('Saved!', '', 'success')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   } else if (result.isDenied) {
                                                      //     // Swal.fire('Changes are not saved', '', 'info')
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   }

                                                      //   if (result.dismiss === Swal.DismissReason.timer) {
                                                      //     this.allPageLoading = true
                                                      //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                      //   }
                                                      // })
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else {
                                                      this.releaseText = csResponse.data.return_data.info_text
                                                      this.releasePercent = csResponse.data.return_data.info_pct

                                                      bar5.set(this.releasePercent);
                                                      // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                      // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                      // console.log('this.releaseText:'+this.releaseText);
                                                      // console.log('this.releasePercent:'+this.releasePercent);

                                                      if(csResponse.data.return_data.info_pct == 100){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                      }
                                                    }
                                                  }
                                                });
                                            }
                                          } else {
                                            Swal.fire({
                                              icon: 'warning',
                                              title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                              timer: 1000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                              }
                                            })
                                          }
                                        }, 3000);
                                      }
                                    });
                                }
                              })
                            } else {
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['success']['swal_title'],
                                response.data.info,
                                'error'
                              )
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  } else {
                    // console.log('#3');
                    Swal.fire(
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_creative_array_swal_title'],
                                this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['lead_messages']['not_creative_array_swal_text'],
                                "error"
                              )
                  }
                } else {
                  axios
                    .post('https://test.autoturn.net/inside/api/tiktok/data/campaign_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      form_data: formData,
                      type: 'release',
                      target: 'add_release_'+this.target,
                    }))
                    .then((response) => {
                      // console.log(response.data);
                      if(response.data.status == 'success'){
                        // this.immediateList = response.data.return_data
                        // this.formData = response.data.return_data.form

                        if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                          let name = this.campaign_name;
                          let currency = this.currencyData.currency;
                          let addition = this.goalsData.budget_increase;
                          let daily_budget = this.methodData.Budget_KW;
                          // let campaignInfo = "依您的預算設定，<br/>在未來兩週將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                          // if(addition == '' || addition == 0){
                          //   campaignInfo = "依您的預算比率與行銷日期設定，<br/>將花費約<span style='color:red;font-weight:bold;'>（"+currency+"）"+daily_budget+"元</span>（預算比率：<span style='color:red;font-weight:bold;'>"+addition+"%</span>）";
                          // }

                          let addition_text = '（'+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                          if(this.methodData.Target_AD == true){
                            addition_text = '';
                          }
                          let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                          let campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_total_budget_c']+"</span>"+addition_text;
                          if(this.dateData.end_date != '0000-00-00'){
                            two_week_budget = this.total_budget;
                            campaignInfo = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_a']+"<br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_not_total_budget_c']+"</span>"+addition_text;
                          }

                          Swal.fire({
                            // title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                            html: campaignInfo + "<br/><br/>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
                            cancelButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // console.log(this.$route.params.id);

                              this.releaseType = true
                              this.style = 'z-index:100;';
                              this.releasePercent = 5;
                              let status = 1;
                              let num = 0;
                              let member_hash = this.$route.params.id;
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);

                              axios
                                .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_release.php', Qs.stringify({
                                  s_code: member_hash,
                                  campaign_id: this.db_campaign_id,
                                }))
                                .then((caResponse) => {
                                  // console.log('caResponse:'+caResponse.data.return_data);
                                  if(caResponse.data.status == 'success'){
                                    //進行進度條
                                    // console.log('發佈莞成，開始跑進度條');
                                    setInterval( () => {
                                      num++;
                                      if(num < 1200){
                                        // console.log('num:'+num);
                                        // console.log(this.releaseType);

                                        if(this.releaseType == true){
                                          axios
                                            .post('https://test.autoturn.net/inside/api/tiktok/campaign/tiktok_campaign_states.php', Qs.stringify({
                                              s_code: member_hash,
                                              adaccount_id: this.advertiser_id,
                                              campaign_id: this.db_campaign_id,
                                            }))
                                            .then((csResponse) => {
                                              // console.log('csResponse:'+csResponse.data.return_data);
                                              //進行進度條
                                              if(status == 1){
                                                if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                  this.releaseType = false
                                                  this.style = 'z-index:-1;';
                                                  bar5.set(0);
                                                  status = 0;
                                                  // Swal.fire({
                                                  //   icon: 'error',
                                                  //   title: '正式發佈',
                                                  //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                  //   showDenyButton: false,
                                                  //   showCancelButton: false,
                                                  //   confirmButtonText: '確定',
                                                  //   timer: 5000
                                                  //   // denyButtonText: `Don't save`,
                                                  // }).then((result) => {
                                                  //   /* Read more about isConfirmed, isDenied below */
                                                  //   if (result.isConfirmed) {
                                                  //     // Swal.fire('Saved!', '', 'success')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   } else if (result.isDenied) {
                                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   }

                                                  //   if (result.dismiss === Swal.DismissReason.timer) {
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   }
                                                  // })
                                                  Swal.fire({
                                                    icon: 'error',
                                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                    text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                  }).then((result) => {

                                                  })
                                                } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                  status = 0;

                                                  axios
                                                    .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                      s_code: member_hash,
                                                      id: this.db_campaign_id,
                                                    }))
                                                    .then((response) => {
                                                      axios
                                                        .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.db_campaign_id)
                                                        .then((csResponse) => {
                                                          this.releaseType = false

                                                          Swal.fire({
                                                            icon: 'success',
                                                            title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                            timer: 5000
                                                            // denyButtonText: `Don't save`,
                                                          }).then((result) => {
                                                            /* Read more about isConfirmed, isDenied below */
                                                            if (result.isConfirmed) {
                                                              // Swal.fire('Saved!', '', 'success')
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                            } else if (result.isDenied) {
                                                              // Swal.fire('Changes are not saved', '', 'info')
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                            }

                                                            if (result.dismiss === Swal.DismissReason.timer) {
                                                              this.allPageLoading = true
                                                              window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                            }
                                                          })
                                                        });
                                                    });
                                                } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                  this.releaseType = false
                                                  this.style = 'z-index:-1;';
                                                  bar5.set(0);
                                                  status = 0;
                                                  // Swal.fire({
                                                  //   icon: 'error',
                                                  //   title: '正式發佈',
                                                  //   text: '發佈失敗：'+csResponse.data.return_data.info_text+'，5秒後將為您重新整理頁面。',
                                                  //   showDenyButton: false,
                                                  //   showCancelButton: false,
                                                  //   confirmButtonText: '確定',
                                                  //   timer: 5000
                                                  //   // denyButtonText: `Don't save`,
                                                  // }).then((result) => {
                                                  //   /* Read more about isConfirmed, isDenied below */
                                                  //   if (result.isConfirmed) {
                                                  //     // Swal.fire('Saved!', '', 'success')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   } else if (result.isDenied) {
                                                  //     // Swal.fire('Changes are not saved', '', 'info')
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   }

                                                  //   if (result.dismiss === Swal.DismissReason.timer) {
                                                  //     this.allPageLoading = true
                                                  //     window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                                  //   }
                                                  // })
                                                  Swal.fire({
                                                    icon: 'error',
                                                    title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                    text:  this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                  }).then((result) => {

                                                  })
                                                } else {
                                                  this.releaseText = csResponse.data.return_data.info_text
                                                  this.releasePercent = csResponse.data.return_data.info_pct

                                                  bar5.set(this.releasePercent);
                                                  // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                  // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                  // console.log('this.releaseText:'+this.releaseText);
                                                  // console.log('this.releasePercent:'+this.releasePercent);

                                                  if(csResponse.data.return_data.info_pct == 100){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                  }
                                                }
                                              }
                                            });
                                        }
                                      } else {
                                        Swal.fire({
                                          icon: 'warning',
                                          title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                          timer: 1000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            window.location.href = "https://dev-private.autoturn.net/events-list/t/"+member_hash+"/"+advertiser_id;
                                          }
                                        })
                                      }
                                    }, 3000);
                                  }
                                });
                            }
                          })
                        } else {
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                            response.data.info,
                            'error'
                          )
                        }

                        // if(type == 1){
                        //   var todayForm = new Date();
                        //   var yearForm = todayForm.getFullYear();
                        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                        //   todayForm = yearForm + monthForm + dateForm + timeForm;

                        //   this.formTitle = 'title_'+todayForm;
                        // } else {
                        //   this.formTitle = response.data.return_data.name;
                        // }

                        // this.showModal = true
                      } else {
                        let text = this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['not_success']['default_swal_text'];
                        if(response.data.info != '' && response.data.info != null){
                          text = response.data.info
                        }
                        Swal.fire(
                          this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                          text,
                          'error'
                        )
                      }
                    });
                }
              }

              if(caResponse.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_title'],
                  text: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['login']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                  }
                })
              }
            });
        }
      }
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }
</style>
